export const familyRelationship=[{
  "name":"Father"
},{
  "name":"Mother"
},{
  "name":"Brother"
},{
  "name":"Sister"
}]

export const catalogCategoryData=[{
  "catid":"218",
  "category":"218 Diaries of Persons",
  "specialAccess":false,
},{
  "catid":"219",
  "category":"Bishops' Letters and Documents",
  "specialAccess":false,
},{
  "catid":"228",
  "category":"Caritas",
  "specialAccess":false,
},{
  "catid":"206",
  "category":"Goa",
  "specialAccess":false,
},{
  "catid":"216.4",
  "category":"Immaculate Conception",
  "specialAccess":false,
},{
  "catid":"225-A",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-B",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-C",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-D",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-E",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-F",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-G",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-H",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-I",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-J",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-K",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-L",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-M",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-N",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-P",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-R",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-S",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-T",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-U",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-V",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-W",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-X",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"225-Y",
  "category":"Jesuit Publications",
  "specialAccess":false,
},{
  "catid":"216.7",
  "category":"Kodaikanal",
  "specialAccess":false,
},{
  "catid":"208.1",
  "category":"Malabar Province",
  "specialAccess":false,
},{
  "catid":"210",
  "category":"Manuscripts",
  "specialAccess":false,
},{
  "catid":"214.1",
  "category":"Manuscripts",
  "specialAccess":false,
},{
  "catid":"216",
  "category":"New Madurai Mission",
  "specialAccess":false,
},{
  "catid":"216.1",
  "category":"New Madurai Mission",
  "specialAccess":false,
},{
  "catid":"216.6",
  "category":"New Madurai Mission",
  "specialAccess":false,
},{
  "catid":"215",
  "category":"New Madurai Mission Letters",
  "specialAccess":false,
},{
  "catid":"211",
  "category":"Old Madura Mission Letters",
  "specialAccess":false,
},{
  "catid":"217",
  "category":"Parish Diaries",
  "specialAccess":true,
},{
  "catid":"220",
  "category":"Parishes Files",
  "specialAccess":false,
},{
  "catid":"223",
  "category":"Religious Orders (Tamil)",
  "specialAccess":false,
},{
  "catid":"214",
  "category":"Reviews Jesuits",
  "specialAccess":false,
},{
  "catid":"216.5",
  "category":"Sacred Heart Brothers",
  "specialAccess":false,
},{
  "catid":"238",
  "category":"Sale Deeds Documents and Records",
  "specialAccess":false,
},{
  "catid":"229",
  "category":"Shenbaganur - Kodaikanal ",
  "specialAccess":false,
},{
  "catid":"216.2",
  "category":"St.Anne's - Chennai",
  "specialAccess":false,
},{
  "catid":"216.3",
  "category":"St.Anne's - Trichy",
  "specialAccess":false,
},{
  "catid":"208.2",
  "category":"Syrian Christians",
  "specialAccess":false,
},{
  "catid":"222",
  "category":"Tamil Manuscripts",
  "specialAccess":false,
},{
  "catid":"221",
  "category":"Tamil Printed Books",
  "specialAccess":false,
}];

export const downloadPaymentHeaders = [
  { label: "Payment ID", key: "paymentID" },
  { label: "Subscriber ID", key: "subscriberID" },
  { label: "Payment Date", key: "transactionDate" },
  { label: "Amount", key: "orderAmount" },
  { label: "Years Renewed", key: "years" },
  { label: "Payment Mode", key: "paymentMode" },
  { label: "Status", key: "txStatus" },
  { label: "Currency", key: "currency" },
];

export const coursesOffered=[{
  "courseID":"VJD-DIP-CRS-01",
  "courseName":"Diploma in Theology",
  "duration":"24 months",
  "fees":7000,
  "courseOption":"Correspondence",
  "payOption":"Full",
  "feesOpted":7000,
  "payStatus":"Pending",
  "grade":'',
  "courseStatus":'Active',
  "courseResult":'',
  "courseCompletedOn":''
},{
  "courseID":"VJD-DIP-ONL-01",
  "courseName":"Diploma in Theology",
  "duration":"24 months",
  "fees":6600,
  "courseOption":"Online",
  "payOption":"Full",
  "feesOpted":6600,
  "payStatus":"Pending",
  "grade":'',
  "courseStatus":'Active',
  "courseResult":'',
  "courseCompletedOn":''
}]

export const feesBreakUpFull=[{
  "feeCategory":"Registration Fee",
  "amount":200
},{
  "feeCategory":"Course Fee for Phase 1",
  "amount":2500
},{
  "feeCategory":"Course Fee for Phase 2",
  "amount":2500
},{
  "feeCategory":"Examination Fee for Phase 1",
  "amount":400
},{
  "feeCategory":"Examination Fee for Phase 2",
  "amount":400
}]

export const feesBreakUpPhase1=[{
  "feeCategory":"Registration Fee",
  "amount":200
},{
  "feeCategory":"Course Fee for Phase 1",
  "amount":2500
},{
  "feeCategory":"Examination Fee for Phase 1",
  "amount":400
}]

export const feesBreakUpPhase2=[{
  "feeCategory":"Registration Fee",
  "amount":200
},{
  "feeCategory":"Course Fee for Phase 2",
  "amount":2500
},{
  "feeCategory":"Examination Fee for Phase 2",
  "amount":400
}]

export const payOptionsData=[{
  "payOptionID":"ID1",
  "payOption":"Full",
  "courseOption":"Online",
  "courseAmount":6600,
  "feesBreakUp":[{
    "feeCategory":"Registration Fee",
    "amount":200
  },{
    "feeCategory":"Course Fee for Phase 1",
    "amount":2800
  },{
    "feeCategory":"Course Fee for Phase 2",
    "amount":2800
  },{
    "feeCategory":"Examination Fee for Phase 1",
    "amount":400
  },{
    "feeCategory":"Examination Fee for Phase 2",
    "amount":400
  }]
},
{
  "payOptionID":"ID2",
  "payOption":"Full",
  "courseOption":"Correspondence",
  "courseAmount":7000,
  "feesBreakUp":[{
    "feeCategory":"Registration Fee",
    "amount":200
  },{
    "feeCategory":"Course Fee for Phase 1",
    "amount":3000
  },{
    "feeCategory":"Course Fee for Phase 2",
    "amount":3000
  },{
    "feeCategory":"Examination Fee for Phase 1",
    "amount":400
  },{
    "feeCategory":"Examination Fee for Phase 2",
    "amount":400
  }]
},
{
  "payOptionID":"ID3",
  "payOption":"Phase1",
  "courseOption":"Online",
  "courseAmount":3400,
  "feesBreakUp":[{
    "feeCategory":"Registration Fee",
    "amount":200
  },{
    "feeCategory":"Course Fee for Phase 1",
    "amount":2800
  },{
    "feeCategory":"Examination Fee for Phase 1",
    "amount":400
  }]
},{
  "payOptionID":"ID4",
  "payOption":"Phase1",
  "courseOption":"Correspondence",
  "courseAmount":3600,
  "feesBreakUp":[{
    "feeCategory":"Registration Fee",
    "amount":200
  },{
    "feeCategory":"Course Fee for Phase 1",
    "amount":2500
  },{
    "feeCategory":"Examination Fee for Phase 1",
    "amount":400
  }]
},{
  "payOptionID":"ID5",
  "payOption":"Phase2",
  "courseOption":"Online",
  "courseAmount":3200,
  "feesBreakUp":[{
    "feeCategory":"Registration Fee",
    "amount":200
  },{
    "feeCategory":"Course Fee for Phase 2",
    "amount":2500
  },{
    "feeCategory":"Examination Fee for Phase 2",
    "amount":400
  }]
},{
  "payOptionID":"ID6",
  "payOption":"Phase2",
  "courseOption":"Correspondence",
  "courseAmount":3400,
  "feesBreakUp":[{
    "feeCategory":"Registration Fee",
    "amount":200
  },{
    "feeCategory":"Course Fee for Phase 2",
    "amount":2500
  },{
    "feeCategory":"Examination Fee for Phase 2",
    "amount":400
  }]
}]

export const courseMaterialData=[
  {
    "semester": 1,
    "courseTitle": "Introduction to Scripture",
    "optional": "N",
    "courseCode": "1Bb01",
    "materialAvailable": "Introd. to Scripture - 1Bb01.pdf",
    "examDueIn": 2,
    "passPercentage": 40,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 21:17",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Pentateuch",
    "optional": "N",
    "courseCode": "1Bb02",
    "materialAvailable": "Pentateuch - 1Bb02.pdf",
    "examDueIn": 1,
    "passPercentage": 40,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 21:18",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Gospel According to Mathew",
    "optional": "N",
    "courseCode": "1Bb05",
    "materialAvailable": "Gospel of Matthew - 1Bb05.pdf",
    "examDueIn": 2,
    "passPercentage": 0,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 21:25",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Historical Books of the Bible",
    "optional": "N",
    "courseCode": "1Bb03",
    "materialAvailable": "Historical Books - 1Bb03.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 21:24",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Gospel According to Mark",
    "optional": "N",
    "courseCode": "1Bb04",
    "materialAvailable": "Gospel of Mark - 1Bb04.pdf",
    "examDueIn": 12,
    "passPercentage": 0,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 21:25",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Gospel According to John",
    "optional": "N",
    "courseCode": "1Bb06",
    "materialAvailable": "Gospel of John - 1Bb06.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 23:09",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "History of Christianity in India",
    "optional": "N",
    "courseCode": "1Bh01",
    "materialAvailable": "History of Christianity in India -1Bh01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "30/03/2017 03:52",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Christian Commitment : Introduction to Moral Theology",
    "optional": "N",
    "courseCode": "1Bm01",
    "materialAvailable": "Christian Commitment - 1Bm01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 00:58",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Vatican Council II - Introduction to the Documents",
    "optional": "N",
    "courseCode": "1Bs06",
    "materialAvailable": "Vatican II - 1Bs06.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:02",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Understanding Faith and Revelation",
    "optional": "N",
    "courseCode": "1Bs04",
    "materialAvailable": "Faith Revelation - 1Bs04.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:01",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Person and Mission of Jesus Christ",
    "optional": "N",
    "courseCode": "1Bs02",
    "materialAvailable": "Christology - 1Bs02.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 00:51",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Mary in Christian Faith",
    "optional": "N",
    "courseCode": "1Bs03",
    "materialAvailable": "Mary in Christian Faith - 1Bs03.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 00:47",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Christian Worship : The Eucharist",
    "optional": "N",
    "courseCode": "1Bs05",
    "materialAvailable": "Eucharist - 1Bs05.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:09",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Book of Psalms",
    "optional": "Y",
    "courseCode": "1Ob01",
    "materialAvailable": "PSALMS - 1Ob01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 50,
    "credits": 1,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "14/05/2017 23:08",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "The Sermon on the Mount/Plain",
    "optional": "Y",
    "courseCode": "1Ob02",
    "materialAvailable": "Sermon on the Mount - 1Ob02.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:09",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Oriental Churches and Theology - An Introduction",
    "optional": "Y",
    "courseCode": "1Os02",
    "materialAvailable": "Oriental Theology - 1Os02.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:10",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Sociology of Religion",
    "optional": "Y",
    "courseCode": "1Os01",
    "materialAvailable": "Sociology of Religion - 1Os01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:11",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Understanding Popular Religiosity",
    "optional": "Y",
    "courseCode": "1Os04",
    "materialAvailable": "Popular Religiosity - 1Os04.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:14",
    "courseStatus": "Active"
  },
  {
    "semester": 1,
    "courseTitle": "Rethinking Conversion in India",
    "optional": "Y",
    "courseCode": "1Os03",
    "materialAvailable": "Conversion in India - 1Os03.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 01:16",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Biblical Prophets",
    "optional": "N",
    "courseCode": "2Bb01",
    "materialAvailable": "The Prophets 2Bb01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:03",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Gospel of Luke",
    "optional": "N",
    "courseCode": "2Bb03",
    "materialAvailable": "Gospel of Luke.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:04",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Acts of the Apostles",
    "optional": "N",
    "courseCode": "2Bb04",
    "materialAvailable": "The Acts of the Apostles - 2Bb04.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:05",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Letters of St.Paul",
    "optional": "N",
    "courseCode": "2Bb02",
    "materialAvailable": "Letters of St Paul - 2Bb02.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:04",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The History of the Church - A Global View",
    "optional": "N",
    "courseCode": "2Bh01",
    "materialAvailable": "Church History-Global-2Bh01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:02",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Marriage and Sexual Ethics",
    "optional": "N",
    "courseCode": "2Bm01",
    "materialAvailable": "MARRIAGE AND SEXUAL ETHICS (Kodi).pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:06",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Social Teaching of the Church",
    "optional": "N",
    "courseCode": "R0026",
    "materialAvailable": null,
    "examDueIn": 0,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": null,
    "modifiedOn": null,
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Introduction to the Canon Law",
    "optional": "Y",
    "courseCode": "2Om02",
    "materialAvailable": "The Canon Law - 2Om02.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:27",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Sacraments : Baptism & Confirmation",
    "optional": "N",
    "courseCode": "2Bs01",
    "materialAvailable": "Baptism & Confirmation - 2Bs01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:12",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Christian Anthropology",
    "optional": "N",
    "courseCode": "2Bs02",
    "materialAvailable": "Christian Anthropology -2Bs02.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:15",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Church",
    "optional": "N",
    "courseCode": "2Bs03",
    "materialAvailable": "The Church - 2Bs03.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:10",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Theology of the Lay Faithful",
    "optional": "N",
    "courseCode": "2Bs04",
    "materialAvailable": "The Lay Faithful - 2Bs04.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 100,
    "credits": 2,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "1",
    "modifiedOn": "18/05/2017 01:35",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Theology of Religion",
    "optional": "N",
    "courseCode": "2Bs05",
    "materialAvailable": "Theology of Religions - 2Bs05.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:24",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Theology of Grace",
    "optional": "Y",
    "courseCode": "2Os03",
    "materialAvailable": "Theology of Grace - 2Os03.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:30",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "The Triune God",
    "optional": "N",
    "courseCode": "2Bs06",
    "materialAvailable": "The Triune God - 2Bs06.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:26",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Justice in the Bible",
    "optional": "Y",
    "courseCode": "R0035",
    "materialAvailable": null,
    "examDueIn": 0,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": null,
    "modifiedOn": null,
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Medical Moral Issues in Christian Perspective",
    "optional": "Y",
    "courseCode": "2Om01",
    "materialAvailable": "Medical-Moral Issues - 2Om01.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:33",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Inter-religious Dialogue",
    "optional": "Y",
    "courseCode": "R0037",
    "materialAvailable": null,
    "examDueIn": 0,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": null,
    "modifiedOn": null,
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Feminist Theology - An Introduction",
    "optional": "Y",
    "courseCode": "2Os04",
    "materialAvailable": "Feminist Theology - 2Os04.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:34",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Dalit Theology - An Introduction",
    "optional": "Y",
    "courseCode": "2Os01",
    "materialAvailable": "Dalit Theology-1.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:35",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Tribal Theology - An Introduction",
    "optional": "Y",
    "courseCode": "2Os02",
    "materialAvailable": "Tribal Theology-1.pdf",
    "examDueIn": 1,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": "30",
    "modifiedOn": "01/04/2017 02:38",
    "courseStatus": "Active"
  },
  {
    "semester": 2,
    "courseTitle": "Liberation Theology - An Introduction",
    "optional": "Y",
    "courseCode": "R0041",
    "materialAvailable": null,
    "examDueIn": 0,
    "passPercentage": 0,
    "maxMark": 0,
    "credits": 0,
    "createdBy": 1,
    "createdOn": "02/02/2017 06:53",
    "modifiedBy": null,
    "modifiedOn": null,
    "courseStatus": "Active"
  }
 ]

export const sampleAssessmentDetails=[
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bb01",
    "courseName": "Introduction to Scripture",
    "assessmentStatus": "Completed",
    "marksObtained": "68",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "21/09/2017 06:50",
    "assessmentDetails":[
      {
        "assessmentID": 1,
        "assessmentMode": "R",
        "assessmentType":"NA",
        "assessmentTakenDate": "10/04/2017",
        "assessmentResponse": "",
        "assessmentObtainedMarks": 68,
        "assessmentTotalMarks": "",
        "assessmentRemarks": "Very good",
        "assessmentResult": "",
        "evaluatedBy": null,
        "evaluatedOn": "13/02/2017"
      },{
        "assessmentID": 2,
        "assessmentMode": "R",
        "assessmentType":"NA",
        "assessmentTakenDate": null,
        "assessmentResponse": "",
        "assessmentObtainedMarks": 0,
        "assessmentTotalMarks": "",
        "assessmentRemarks": null,
        "assessmentResult": "",
        "evaluatedBy": null,
        "evaluatedOn": "13/02/2017"
      }
     ]
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bb02",
    "courseName": "The Pentateuch",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "21/09/2017 06:50",
    "assessmentDetails": [
      {
        "assessmentID": 2,
        "assessmentMode": "R",
        "assessmentType":"NA",
        "assessmentTakenDate": null,
        "assessmentResponse": "",
        "assessmentObtainedMarks": 0,
        "assessmentTotalMarks": "",
        "assessmentRemarks": null,
        "assessmentResult": "",
        "evaluatedBy": null,
        "evaluatedOn": "13/02/2017 06:37"
      }
     ]
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bb05",
    "courseName": "The Gospel According to Mathew",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "21/09/2017 06:49",
    "assessmentDetails": [
      {
        "assessmentID": 3,
        "assessmentMode": "R",
        "assessmentType":"NA",
        "assessmentTakenDate": null,
        "assessmentResponse": "",
        "assessmentObtainedMarks": 0,
        "assessmentTotalMarks": "",
        "assessmentRemarks": null,
        "assessmentResult": "",
        "evaluatedBy": null,
        "evaluatedOn": "13/02/2017 06:37"
      }
     ]
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bb03",
    "courseName": "The Historical Books of the Bible",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "21/09/2017 06:50",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bb04",
    "courseName": "The Gospel According to Mark",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "21/09/2017 06:49",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bb06",
    "courseName": "The Gospel According to John",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "20/04/2017 22:45",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bh01",
    "courseName": "History of Christianity in India",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bm01",
    "courseName": "Christian Commitment : Introduction to Moral Theology",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bs06",
    "courseName": "Vatican Council II - Introduction to the Documents",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bs04",
    "courseName": "Understanding Faith and Revelation",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bs02",
    "courseName": "The Person and Mission of Jesus Christ",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bs03",
    "courseName": "Mary in Christian Faith",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Bs05",
    "courseName": "Christian Worship : The Eucharist",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "20/04/2017 22:45",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Ob01",
    "courseName": "The Book of Psalms",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Ob02",
    "courseName": "The Sermon on the Mount/Plain",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Os02",
    "courseName": "Oriental Churches and Theology - An Introduction",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1316",
    "courseCode": "1Os01",
    "courseName": "Sociology of Religion",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bb01",
    "courseName": "Introduction to Scripture",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:33",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bb02",
    "courseName": "The Pentateuch",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:39",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bb05",
    "courseName": "The Gospel According to Mathew",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:38",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bb03",
    "courseName": "The Historical Books of the Bible",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:41",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bb04",
    "courseName": "The Gospel According to Mark",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:42",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bb06",
    "courseName": "The Gospel According to John",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:43",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bh01",
    "courseName": "History of Christianity in India",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:44",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bm01",
    "courseName": "Christian Commitment : Introduction to Moral Theology",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:45",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bs06",
    "courseName": "Vatican Council II - Introduction to the Documents",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:46",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bs04",
    "courseName": "Understanding Faith and Revelation",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:46",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bs02",
    "courseName": "The Person and Mission of Jesus Christ",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:47",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bs03",
    "courseName": "Mary in Christian Faith",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:48",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Bs05",
    "courseName": "Christian Worship : The Eucharist",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:49",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Ob01",
    "courseName": "The Book of Psalms",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:54",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Ob02",
    "courseName": "The Sermon on the Mount/Plain",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:55",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1309",
    "courseCode": "1Os01",
    "courseName": "Sociology of Religion",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:56",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bb01",
    "courseName": "Introduction to Scripture",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "01/05/2019 06:09",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bb02",
    "courseName": "The Pentateuch",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bb05",
    "courseName": "The Gospel According to Mathew",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": "30",
    "updatedOn": "22/03/2017 01:11",
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bb03",
    "courseName": "The Historical Books of the Bible",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bb04",
    "courseName": "The Gospel According to Mark",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bb06",
    "courseName": "The Gospel According to John",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bh01",
    "courseName": "History of Christianity in India",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bm01",
    "courseName": "Christian Commitment : Introduction to Moral Theology",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bs06",
    "courseName": "Vatican Council II - Introduction to the Documents",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bs04",
    "courseName": "Understanding Faith and Revelation",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bs02",
    "courseName": "The Person and Mission of Jesus Christ",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bs03",
    "courseName": "Mary in Christian Faith",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Bs05",
    "courseName": "Christian Worship : The Eucharist",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Ob01",
    "courseName": "The Book of Psalms",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Ob02",
    "courseName": "The Sermon on the Mount/Plain",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Os02",
    "courseName": "Oriental Churches and Theology - An Introduction",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  },
  {
    "registrationNo": "16-VJD-1310",
    "courseCode": "1Os01",
    "courseName": "Sociology of Religion",
    "assessmentStatus": "Completed",
    "marksObtained": "",
    "assessmentCategory": "Term",
    "updatedBy": null,
    "updatedOn": null,
    "assessmentDetails": ""
  }
 ]

 export const journalCategory=[{
  "id":1,
  "category":"A",
  "details":"Abroad"
},{
  "id":2,
  "category":"AM",
  "details":"Abroad Multiple"
},{
  "id":3,
  "category":"AE",
  "details":"Abroad E-Subscription"
},{
  "id":4,
  "category":"AX",
  "details":"Abroad Exchange"
},{
  "id":5,
  "category":"AC",
  "details":"Abroad Complimentary"
},{
  "id":6,
  "category":"I",
  "details":"Indian"
},{
  "id":7,
  "category":"IM",
  "details":"Indian Multiple"
},{
  "id":8,
  "category":"IE",
  "details":"Indian E-Subscription"
},{
  "id":9,
  "category":"IX",
  "details":"Indian Exchange"
},{
  "id":10,
  "category":"IC",
  "details":"Indian Complimentary"
},{
  "id":11,
  "category":"F",
  "details":"F"
},{
  "id":12,
  "category":"FX",
  "details":"FX"
},{
  "id":13,
  "category":"FM",
  "details":"FM"
},{
  "id":14,
  "category":"CAT",
  "details":"CAT"
},{
  "id":15,
  "category":"COMP",
  "details":"COMP"
}];


 export const sampleQuestionTable=[{
    "courseCode":"123",
    "questionID":"123-1",
    "courseName":"TESTING",
    "assessmentCategory":"Online",
    "assessmentAssignedTo":"TEST",
    "assessmentOpenDate":"XXX",
    "assessmentEndDate":"YYY",
    "assessmentStatus":"Active",
    "assessmentType":"YesNo",
    "assessmentQuestions":[{}],
    "assessmentAnswers":[{}],
    "createdBy":"AAA",
    "createdOn":"AAA",
    "updatedBy":"AAA",
    "updatedOn":"AAA"
  },{
    "courseCode":"1Bb05",
    "questionID":"1Bb05-1",
    "courseName":"The Gospel According to Mathew",
    "assessmentCategory":"Online",
    "assessmentAssignedTo":"TEST",
    "assessmentOpenDate":"XXX",
    "assessmentEndDate":"YYY",
    "assessmentStatus":"Active",
    "assessmentType":"YesNo",
    "assessmentQuestions":[{
        "questionID": 1,
        "questionTitle": "According to tradition, St Thomas landed in Kodungalloor and died in Mylapore.\n"
        },
        {
          "questionID": 2,
          "questionTitle": "St Thomas founded seven Christian communities in Mylapore."
        },
        {
          "questionID": 3,
          "questionTitle": "According to Christian traditions, the apostles St Thomas and St Bartholomew preached the Gospel in India and went to form Christian communities in Japan."
        }],
    "assessmentAnswers":[{
      "questionID": 1,
      "questionTitle": "According to tradition, St Thomas landed in Kodungalloor and died in Mylapore.\n",
      "keys":"Yes"
      },
      {
        "questionID": 2,
        "questionTitle": "St Thomas founded seven Christian communities in Mylapore.",
        "keys":"Yes"
      },
      {
        "questionID": 3,
        "questionTitle": "According to Christian traditions, the apostles St Thomas and St Bartholomew preached the Gospel in India and went to form Christian communities in Japan.",
        "keys":"No"
      }],
    "createdBy":"AAA",
    "createdOn":"AAA",
    "updatedBy":"AAA",
    "updatedOn":"AAA"
  },{
    "courseCode":"TEST",
    "questionID":"1Bb05-1",
    "courseName":"The Gospel According to Mathew",
    "assessmentCategory":"Online",
    "assessmentAssignedTo":"TEST",
    "assessmentOpenDate":"XXX",
    "assessmentEndDate":"YYY",
    "assessmentStatus":"Active",
    "assessmentType":"MCQ",
    "assessmentQuestions":[
      {
        "questionID": 1,
        "questionTitle": "The word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722", "value":false},{"option":"b","choice":"Inter-Testamental period", "value":false},{"option":"c","choice":"Yahweh and Israel", "value":false},{"option":"d","choice":"Covenant", "value":false}]
      },
      {
        "questionID": 2,
        "questionTitle": "word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722", "value":false},{"option":"b","choice":"Inter-Testamental period", "value":false},{"option":"c","choice":"Yahweh and Israel", "value":false},{"option":"d","choice":"Covenant", "value":false}]
      },
      {
        "questionID": 3,
        "questionTitle": "'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722", "value":false},{"option":"b","choice":"Inter-Testamental period", "value":false},{"option":"c","choice":"Yahweh and Israel", "value":false},{"option":"d","choice":"Covenant", "value":false}]
      },
      {
        "questionID": 4,
        "questionTitle": "derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722", "value":false},{"option":"b","choice":"Inter-Testamental period", "value":false},{"option":"c","choice":"Yahweh and Israel", "value":false},{"option":"d","choice":"Covenant", "value":false}]
      }],
    "assessmentAnswers":[
      {
        "questionID": 1,
        "questionTitle": "The word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722"},{"option":"b","choice":"Inter-Testamental period"},{"option":"c","choice":"Yahweh and Israel"},{"option":"d","choice":"Covenant"}],
        "keys":"a"
      },
      {
        "questionID": 2,
        "questionTitle": "word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722"},{"option":"b","choice":"Inter-Testamental period"},{"option":"c","choice":"Yahweh and Israel"},{"option":"d","choice":"Covenant"}],
        "keys":"b"
      },
      {
        "questionID": 3,
        "questionTitle": "'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722"},{"option":"b","choice":"Inter-Testamental period"},{"option":"c","choice":"Yahweh and Israel"},{"option":"d","choice":"Covenant"}],
        "keys":"c"
      },
      {
        "questionID": 4,
        "questionTitle": "derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "choices":[{"option":"a","choice":"722"},{"option":"b","choice":"Inter-Testamental period"},{"option":"c","choice":"Yahweh and Israel"},{"option":"d","choice":"Covenant"}],
        "keys":"d"
      }
     ],
    "createdBy":"AAA",
    "createdOn":"AAA",
    "updatedBy":"AAA",
    "updatedOn":"AAA"
  },{
    "courseCode":"1Bb05",
    "questionID":"1Bb05-2",
    "courseName":"The Gospel According to Mathew",
    "assessmentCategory":"Online",
    "assessmentAssignedTo":"TEST",
    "assessmentOpenDate":"XXX",
    "assessmentEndDate":"YYY",
    "assessmentStatus":"Active",
    "assessmentType":"Descriptive",
    "assessmentQuestions":[
      {
        "questionID": 1,
        "questionTitle": "The word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":""
      },
      {
        "questionID": 2,
        "questionTitle": "word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":""
      },
      {
        "questionID": 3,
        "questionTitle": "'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":""
      },
      {
        "questionID": 4,
        "questionTitle": "derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":""
      }],
    "assessmentAnswers":[
      {
        "questionID": 1,
        "questionTitle": "The word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":"Test"
      },
      {
        "questionID": 2,
        "questionTitle": "word 'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":"Test1"
      },
      {
        "questionID": 3,
        "questionTitle": "'testament' is derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":"Test2"
      },
      {
        "questionID": 4,
        "questionTitle": "derived from a Latin word testamentum, which is chosen to translate a biblical word ______________.",
        "keys":"Test3"
      }
     ],
    "createdBy":"AAA",
    "createdOn":"AAA",
    "updatedBy":"AAA",
    "updatedOn":"AAA"
  }];

export const phoneCode=[
    {
      "Country": "USA",
      "Code": "+1"
    },
    {
      "Country": "RUS",
      "Code": "+7"
    },
    {
      "Country": "EGY",
      "Code": "+20"
    },
    {
      "Country": "ZAF",
      "Code": "+27"
    },
    {
      "Country": "GRC",
      "Code": "+30"
    },
    {
      "Country": "NLD",
      "Code": "+31"
    },
    {
      "Country": "BEL",
      "Code": "+32"
    },
    {
      "Country": "FRA",
      "Code": "+33"
    },
    {
      "Country": "ESP",
      "Code": "+34"
    },
    {
      "Country": "HUN",
      "Code": "+36"
    },
    {
      "Country": "ITA",
      "Code": "+39"
    },
    {
      "Country": "ROU",
      "Code": "+40"
    },
    {
      "Country": "CHE",
      "Code": "+41"
    },
    {
      "Country": "AUT",
      "Code": "+43"
    },
    {
      "Country": "GBR",
      "Code": "+44"
    },
    {
      "Country": "DNK",
      "Code": "+45"
    },
    {
      "Country": "SWE",
      "Code": "+46"
    },
    {
      "Country": "NOR",
      "Code": "+47"
    },
    {
      "Country": "POL",
      "Code": "+48"
    },
    {
      "Country": "DEU",
      "Code": "+49"
    },
    {
      "Country": "PER",
      "Code": "+51"
    },
    {
      "Country": "MEX",
      "Code": "+52"
    },
    {
      "Country": "CUB",
      "Code": "+53"
    },
    {
      "Country": "ARG",
      "Code": "+54"
    },
    {
      "Country": "BRA",
      "Code": "+55"
    },
    {
      "Country": "CHL",
      "Code": "+56"
    },
    {
      "Country": "COL",
      "Code": "+57"
    },
    {
      "Country": "VEN",
      "Code": "+58"
    },
    {
      "Country": "MYS",
      "Code": "+60"
    },
    {
      "Country": "AUS",
      "Code": "+61"
    },
    {
      "Country": "IDN",
      "Code": "+62"
    },
    {
      "Country": "PHL",
      "Code": "+63"
    },
    {
      "Country": "NZL",
      "Code": "+64"
    },
    {
      "Country": "SGP",
      "Code": "+65"
    },
    {
      "Country": "THA",
      "Code": "+66"
    },
    {
      "Country": "JPN",
      "Code": "+81"
    },
    {
      "Country": "KOR",
      "Code": "+82"
    },
    {
      "Country": "VNM",
      "Code": "+84"
    },
    {
      "Country": "CHN",
      "Code": "+86"
    },
    {
      "Country": "TUR",
      "Code": "+90"
    },
    {
      "Country": "IND",
      "Code": "+91"
    },
    {
      "Country": "PAK",
      "Code": "+92"
    },
    {
      "Country": "AFG",
      "Code": "+93"
    },
    {
      "Country": "LKA",
      "Code": "+94"
    },
    {
      "Country": "MMR",
      "Code": "+95"
    },
    {
      "Country": "IRN",
      "Code": "+98"
    },
    {
      "Country": "SSD",
      "Code": "+211"
    },
    {
      "Country": "ESH",
      "Code": "+212"
    },
    {
      "Country": "DZA",
      "Code": "+213"
    },
    {
      "Country": "TUN",
      "Code": "+216"
    },
    {
      "Country": "LBY",
      "Code": "+218"
    },
    {
      "Country": "GMB",
      "Code": "+220"
    },
    {
      "Country": "SEN",
      "Code": "+221"
    },
    {
      "Country": "MRT",
      "Code": "+222"
    },
    {
      "Country": "MLI",
      "Code": "+223"
    },
    {
      "Country": "GIN",
      "Code": "+224"
    },
    {
      "Country": "CIV",
      "Code": "+225"
    },
    {
      "Country": "BFA",
      "Code": "+226"
    },
    {
      "Country": "NER",
      "Code": "+227"
    },
    {
      "Country": "TGO",
      "Code": "+228"
    },
    {
      "Country": "BEN",
      "Code": "+229"
    },
    {
      "Country": "MUS",
      "Code": "+230"
    },
    {
      "Country": "LBR",
      "Code": "+231"
    },
    {
      "Country": "SLE",
      "Code": "+232"
    },
    {
      "Country": "GHA",
      "Code": "+233"
    },
    {
      "Country": "NGA",
      "Code": "+234"
    },
    {
      "Country": "TCD",
      "Code": "+235"
    },
    {
      "Country": "CAF",
      "Code": "+236"
    },
    {
      "Country": "CMR",
      "Code": "+237"
    },
    {
      "Country": "CPV",
      "Code": "+238"
    },
    {
      "Country": "STP",
      "Code": "+239"
    },
    {
      "Country": "GNQ",
      "Code": "+240"
    },
    {
      "Country": "GAB",
      "Code": "+241"
    },
    {
      "Country": "COG",
      "Code": "+242"
    },
    {
      "Country": "COD",
      "Code": "+243"
    },
    {
      "Country": "AGO",
      "Code": "+244"
    },
    {
      "Country": "GNB",
      "Code": "+245"
    },
    {
      "Country": "IOT",
      "Code": "+246"
    },
    {
      "Country": "SYC",
      "Code": "+248"
    },
    {
      "Country": "SDN",
      "Code": "+249"
    },
    {
      "Country": "RWA",
      "Code": "+250"
    },
    {
      "Country": "ETH",
      "Code": "+251"
    },
    {
      "Country": "SOM",
      "Code": "+252"
    },
    {
      "Country": "DJI",
      "Code": "+253"
    },
    {
      "Country": "KEN",
      "Code": "+254"
    },
    {
      "Country": "TZA",
      "Code": "+255"
    },
    {
      "Country": "UGA",
      "Code": "+256"
    },
    {
      "Country": "BDI",
      "Code": "+257"
    },
    {
      "Country": "MOZ",
      "Code": "+258"
    },
    {
      "Country": "ZMB",
      "Code": "+260"
    },
    {
      "Country": "MDG",
      "Code": "+261"
    },
    {
      "Country": "REU",
      "Code": "+262"
    },
    {
      "Country": "ZWE",
      "Code": "+263"
    },
    {
      "Country": "NAM",
      "Code": "+264"
    },
    {
      "Country": "MWI",
      "Code": "+265"
    },
    {
      "Country": "LSO",
      "Code": "+266"
    },
    {
      "Country": "BWA",
      "Code": "+267"
    },
    {
      "Country": "SWZ",
      "Code": "+268"
    },
    {
      "Country": "COM",
      "Code": "+269"
    },
    {
      "Country": "SHN",
      "Code": "+290"
    },
    {
      "Country": "ERI",
      "Code": "+291"
    },
    {
      "Country": "ABW",
      "Code": "+297"
    },
    {
      "Country": "FRO",
      "Code": "+298"
    },
    {
      "Country": "GRL",
      "Code": "+299"
    },
    {
      "Country": "GIB",
      "Code": "+350"
    },
    {
      "Country": "PRT",
      "Code": "+351"
    },
    {
      "Country": "LUX",
      "Code": "+352"
    },
    {
      "Country": "IRL",
      "Code": "+353"
    },
    {
      "Country": "ISL",
      "Code": "+354"
    },
    {
      "Country": "ALB",
      "Code": "+355"
    },
    {
      "Country": "MLT",
      "Code": "+356"
    },
    {
      "Country": "CYP",
      "Code": "+357"
    },
    {
      "Country": "FIN",
      "Code": "+358"
    },
    {
      "Country": "BGR",
      "Code": "+359"
    },
    {
      "Country": "LTU",
      "Code": "+370"
    },
    {
      "Country": "LVA",
      "Code": "+371"
    },
    {
      "Country": "EST",
      "Code": "+372"
    },
    {
      "Country": "MDA",
      "Code": "+373"
    },
    {
      "Country": "ARM",
      "Code": "+374"
    },
    {
      "Country": "BLR",
      "Code": "+375"
    },
    {
      "Country": "AND",
      "Code": "+376"
    },
    {
      "Country": "MCO",
      "Code": "+377"
    },
    {
      "Country": "SMR",
      "Code": "+378"
    },
    {
      "Country": "UKR",
      "Code": "+380"
    },
    {
      "Country": "SRB",
      "Code": "+381"
    },
    {
      "Country": "MNE",
      "Code": "+382"
    },
    {
      "Country": "XKX",
      "Code": "+383"
    },
    {
      "Country": "HRV",
      "Code": "+385"
    },
    {
      "Country": "SVN",
      "Code": "+386"
    },
    {
      "Country": "BIH",
      "Code": "+387"
    },
    {
      "Country": "MKD",
      "Code": "+389"
    },
    {
      "Country": "CZE",
      "Code": "+420"
    },
    {
      "Country": "SVK",
      "Code": "+421"
    },
    {
      "Country": "LIE",
      "Code": "+423"
    },
    {
      "Country": "FLK",
      "Code": "+500"
    },
    {
      "Country": "BLZ",
      "Code": "+501"
    },
    {
      "Country": "GTM",
      "Code": "+502"
    },
    {
      "Country": "SLV",
      "Code": "+503"
    },
    {
      "Country": "HND",
      "Code": "+504"
    },
    {
      "Country": "NIC",
      "Code": "+505"
    },
    {
      "Country": "CRI",
      "Code": "+506"
    },
    {
      "Country": "PAN",
      "Code": "+507"
    },
    {
      "Country": "SPM",
      "Code": "+508"
    },
    {
      "Country": "HTI",
      "Code": "+509"
    },
    {
      "Country": "BLM",
      "Code": "+590"
    },
    {
      "Country": "BOL",
      "Code": "+591"
    },
    {
      "Country": "GUY",
      "Code": "+592"
    },
    {
      "Country": "ECU",
      "Code": "+593"
    },
    {
      "Country": "PRY",
      "Code": "+595"
    },
    {
      "Country": "SUR",
      "Code": "+597"
    },
    {
      "Country": "URY",
      "Code": "+598"
    },
    {
      "Country": "ANT",
      "Code": "+599"
    },
    {
      "Country": "TLS",
      "Code": "+670"
    },
    {
      "Country": "ATA",
      "Code": "+672"
    },
    {
      "Country": "BRN",
      "Code": "+673"
    },
    {
      "Country": "NRU",
      "Code": "+674"
    },
    {
      "Country": "PNG",
      "Code": "+675"
    },
    {
      "Country": "TON",
      "Code": "+676"
    },
    {
      "Country": "SLB",
      "Code": "+677"
    },
    {
      "Country": "VUT",
      "Code": "+678"
    },
    {
      "Country": "FJI",
      "Code": "+679"
    },
    {
      "Country": "PLW",
      "Code": "+680"
    },
    {
      "Country": "WLF",
      "Code": "+681"
    },
    {
      "Country": "COK",
      "Code": "+682"
    },
    {
      "Country": "NIU",
      "Code": "+683"
    },
    {
      "Country": "WSM",
      "Code": "+685"
    },
    {
      "Country": "KIR",
      "Code": "+686"
    },
    {
      "Country": "NCL",
      "Code": "+687"
    },
    {
      "Country": "TUV",
      "Code": "+688"
    },
    {
      "Country": "PYF",
      "Code": "+689"
    },
    {
      "Country": "TKL",
      "Code": "+690"
    },
    {
      "Country": "FSM",
      "Code": "+691"
    },
    {
      "Country": "MHL",
      "Code": "+692"
    },
    {
      "Country": "PRK",
      "Code": "+850"
    },
    {
      "Country": "HKG",
      "Code": "+852"
    },
    {
      "Country": "MAC",
      "Code": "+853"
    },
    {
      "Country": "KHM",
      "Code": "+855"
    },
    {
      "Country": "LAO",
      "Code": "+856"
    },
    {
      "Country": "BGD",
      "Code": "+880"
    },
    {
      "Country": "TWN",
      "Code": "+886"
    },
    {
      "Country": "MDV",
      "Code": "+960"
    },
    {
      "Country": "LBN",
      "Code": "+961"
    },
    {
      "Country": "JOR",
      "Code": "+962"
    },
    {
      "Country": "SYR",
      "Code": "+963"
    },
    {
      "Country": "IRQ",
      "Code": "+964"
    },
    {
      "Country": "KWT",
      "Code": "+965"
    },
    {
      "Country": "SAU",
      "Code": "+966"
    },
    {
      "Country": "YEM",
      "Code": "+967"
    },
    {
      "Country": "OMN",
      "Code": "+968"
    },
    {
      "Country": "PSE",
      "Code": "+970"
    },
    {
      "Country": "ARE",
      "Code": "+971"
    },
    {
      "Country": "ISR",
      "Code": "+972"
    },
    {
      "Country": "BHR",
      "Code": "+973"
    },
    {
      "Country": "QAT",
      "Code": "+974"
    },
    {
      "Country": "BTN",
      "Code": "+975"
    },
    {
      "Country": "MNG",
      "Code": "+976"
    },
    {
      "Country": "NPL",
      "Code": "+977"
    },
    {
      "Country": "TJK",
      "Code": "+992"
    },
    {
      "Country": "TKM",
      "Code": "+993"
    },
    {
      "Country": "AZE",
      "Code": "+994"
    },
    {
      "Country": "GEO",
      "Code": "+995"
    },
    {
      "Country": "KGZ",
      "Code": "+996"
    },
    {
      "Country": "UZB",
      "Code": "+998"
    }
  ];

  export const downloadHeaders = [
    { label: "Title", key: "title" },
    { label: "Name", key: "applicantName" },
    { label: "Registration No", key: "registrationNo" },
    { label: "Application No", key: "applicationNo" },
    { label: "Application Status", key: "applicationStatus" },
    { label: "Application Date", key: "applicationDate" },
    { label: "Email", key: "emailID" },
    { label: "Mobile", key: "mobileNumber" },
    { label: "Mother Tongue", key: "motherTongue" },
    { label: "State", key: "addressState" },
    { label: "Gender", key: "gender" },
    { label: "Maritial Status", key: "maritial Status" },
    { label: "Religion", key: "religion" }
  ];

  export const downloadCatalogueHeaders = [
    { label: "Accession No", key: "catalogueID" },
    { label: "Title", key: "title" },
    { label: "Author", key: "author" },
    { label: "Category", key: "category" },
    { label: "Self", key: "self" },
    { label: "Status", key: "catalogueStatus" },
    { label: "Book No", key: "bookNo" },
    { label: "Special Access", key: "specialAccess" }
  ];

  export const downloadFeeHeaders = [
    { label: "Title", key: "title" },
    { label: "Name", key: "applicantName" },
    { label: "Registration No", key: "registrationNo" },
    { label: "Application Date", key: "applicationDate" },
    { label: "Email", key: "emailID" },
    { label: "Mobile", key: "mobileNumber" },
    { label: "Payment Status", key: "coursePayment" },
    { label: "Course Status", key: "courseStatus" }

  ];

  export const downloadCourseHeaders=[
    { label: "Code", key: "courseCode" },
    { label: "Title", key: "courseTitle" },
    { label: "semester", key: "semester" }
  ];

  export const downloadAssessmentHeaders=[
    { label: "Assessment ID", key: "assessmentID" },
    { label: "Registration No", key: "registrationNo" },
    { label: "Course Code", key: "courseCode" },
    { label: "Course Name", key: "courseName" },
    { label: "Category", key: "assessmentCategory" },
    { label: "Grade", key: "assessmentGrade" },
    { label: "Remarks", key: "assessmentRemarks" },
    { label: "Result", key: "assessmentResult" },
    { label: "Status", key: "assessmentStatus" },
    { label: "Evaluated By", key: "evaluatedBy" },
    { label: "Evaluated On", key: "evaluatedOn" },
    { label: "Exam Date", key: "examDate" },
    { label: "Exam Type", key: "examType" },
    { label: "Total Marks", key: "totalMarks" },
    { label: "Marks Obtained", key: "totalMarksObtained" },
    { label: "Evaluated On", key: "evaluatedOn" },
    { label: "Exam Date", key: "examDate" }
  ];

  export const downloadEvaluationHeaders = [
    { label: "Registration No", key: "registrationNo" },
    { label: "Assessment ID", key: "assessmentID" },
    { label: "Course Name", key: "courseName" },
    { label: "Exam Type", key: "examType" },
    { label: "Exam Date", key: "examDate" }
  ];

  export const downloadQuestionHeaders=[
    { label: "Question ID", key: "questionID" },
    { label: "Course Code", key: "courseCode" },
    { label: "Course Name", key: "courseName" },
    { label: "Assigned To", key: "assessmentAssignedTo" },
    { label: "Category", key: "assessmentCategory" },
    { label: "Exam Start Date", key: "assessmentOpenDate" },
    { label: "Exam End Date", key: "assessmentEndDate" },
    { label: "Status", key: "assessmentStatus" },
    { label: "Question Type", key: "assessmentType" }
  ]

  export const eventsColour = [{
    id: 'Online Class',
    color: '#8E44AD'
}, {
    id: 'Offline Class',
    color: '#2874A6'
},{
    id: 'Exams',
    color: '#138D75'
}, {
    id: 'Seminars',
    color: '#D4AC0D'
}];
  
  export const nationalData = [
    {
        "num_code": "4",
        "alpha_2_code": "AF",
        "alpha_3_code": "AFG",
        "en_short_name": "Afghanistan",
        "nationality": "Afghan"
    },
    {
        "num_code": "248",
        "alpha_2_code": "AX",
        "alpha_3_code": "ALA",
        "en_short_name": "\u00c5land Islands",
        "nationality": "\u00c5land Island"
    },
    {
        "num_code": "8",
        "alpha_2_code": "AL",
        "alpha_3_code": "ALB",
        "en_short_name": "Albania",
        "nationality": "Albanian"
    },
    {
        "num_code": "12",
        "alpha_2_code": "DZ",
        "alpha_3_code": "DZA",
        "en_short_name": "Algeria",
        "nationality": "Algerian"
    },
    {
        "num_code": "16",
        "alpha_2_code": "AS",
        "alpha_3_code": "ASM",
        "en_short_name": "American Samoa",
        "nationality": "American Samoan"
    },
    {
        "num_code": "20",
        "alpha_2_code": "AD",
        "alpha_3_code": "AND",
        "en_short_name": "Andorra",
        "nationality": "Andorran"
    },
    {
        "num_code": "24",
        "alpha_2_code": "AO",
        "alpha_3_code": "AGO",
        "en_short_name": "Angola",
        "nationality": "Angolan"
    },
    {
        "num_code": "660",
        "alpha_2_code": "AI",
        "alpha_3_code": "AIA",
        "en_short_name": "Anguilla",
        "nationality": "Anguillan"
    },
    {
        "num_code": "10",
        "alpha_2_code": "AQ",
        "alpha_3_code": "ATA",
        "en_short_name": "Antarctica",
        "nationality": "Antarctic"
    },
    {
        "num_code": "28",
        "alpha_2_code": "AG",
        "alpha_3_code": "ATG",
        "en_short_name": "Antigua and Barbuda",
        "nationality": "Antiguan or Barbudan"
    },
    {
        "num_code": "32",
        "alpha_2_code": "AR",
        "alpha_3_code": "ARG",
        "en_short_name": "Argentina",
        "nationality": "Argentine"
    },
    {
        "num_code": "51",
        "alpha_2_code": "AM",
        "alpha_3_code": "ARM",
        "en_short_name": "Armenia",
        "nationality": "Armenian"
    },
    {
        "num_code": "533",
        "alpha_2_code": "AW",
        "alpha_3_code": "ABW",
        "en_short_name": "Aruba",
        "nationality": "Aruban"
    },
    {
        "num_code": "36",
        "alpha_2_code": "AU",
        "alpha_3_code": "AUS",
        "en_short_name": "Australia",
        "nationality": "Australian"
    },
    {
        "num_code": "40",
        "alpha_2_code": "AT",
        "alpha_3_code": "AUT",
        "en_short_name": "Austria",
        "nationality": "Austrian"
    },
    {
        "num_code": "31",
        "alpha_2_code": "AZ",
        "alpha_3_code": "AZE",
        "en_short_name": "Azerbaijan",
        "nationality": "Azerbaijani, Azeri"
    },
    {
        "num_code": "44",
        "alpha_2_code": "BS",
        "alpha_3_code": "BHS",
        "en_short_name": "Bahamas",
        "nationality": "Bahamian"
    },
    {
        "num_code": "48",
        "alpha_2_code": "BH",
        "alpha_3_code": "BHR",
        "en_short_name": "Bahrain",
        "nationality": "Bahraini"
    },
    {
        "num_code": "50",
        "alpha_2_code": "BD",
        "alpha_3_code": "BGD",
        "en_short_name": "Bangladesh",
        "nationality": "Bangladeshi"
    },
    {
        "num_code": "52",
        "alpha_2_code": "BB",
        "alpha_3_code": "BRB",
        "en_short_name": "Barbados",
        "nationality": "Barbadian"
    },
    {
        "num_code": "112",
        "alpha_2_code": "BY",
        "alpha_3_code": "BLR",
        "en_short_name": "Belarus",
        "nationality": "Belarusian"
    },
    {
        "num_code": "56",
        "alpha_2_code": "BE",
        "alpha_3_code": "BEL",
        "en_short_name": "Belgium",
        "nationality": "Belgian"
    },
    {
        "num_code": "84",
        "alpha_2_code": "BZ",
        "alpha_3_code": "BLZ",
        "en_short_name": "Belize",
        "nationality": "Belizean"
    },
    {
        "num_code": "204",
        "alpha_2_code": "BJ",
        "alpha_3_code": "BEN",
        "en_short_name": "Benin",
        "nationality": "Beninese, Beninois"
    },
    {
        "num_code": "60",
        "alpha_2_code": "BM",
        "alpha_3_code": "BMU",
        "en_short_name": "Bermuda",
        "nationality": "Bermudian, Bermudan"
    },
    {
        "num_code": "64",
        "alpha_2_code": "BT",
        "alpha_3_code": "BTN",
        "en_short_name": "Bhutan",
        "nationality": "Bhutanese"
    },
    {
        "num_code": "68",
        "alpha_2_code": "BO",
        "alpha_3_code": "BOL",
        "en_short_name": "Bolivia (Plurinational State of)",
        "nationality": "Bolivian"
    },
    {
        "num_code": "535",
        "alpha_2_code": "BQ",
        "alpha_3_code": "BES",
        "en_short_name": "Bonaire, Sint Eustatius and Saba",
        "nationality": "Bonaire"
    },
    {
        "num_code": "70",
        "alpha_2_code": "BA",
        "alpha_3_code": "BIH",
        "en_short_name": "Bosnia and Herzegovina",
        "nationality": "Bosnian or Herzegovinian"
    },
    {
        "num_code": "72",
        "alpha_2_code": "BW",
        "alpha_3_code": "BWA",
        "en_short_name": "Botswana",
        "nationality": "Motswana, Botswanan"
    },
    {
        "num_code": "74",
        "alpha_2_code": "BV",
        "alpha_3_code": "BVT",
        "en_short_name": "Bouvet Island",
        "nationality": "Bouvet Island"
    },
    {
        "num_code": "76",
        "alpha_2_code": "BR",
        "alpha_3_code": "BRA",
        "en_short_name": "Brazil",
        "nationality": "Brazilian"
    },
    {
        "num_code": "86",
        "alpha_2_code": "IO",
        "alpha_3_code": "IOT",
        "en_short_name": "British Indian Ocean Territory",
        "nationality": "BIOT"
    },
    {
        "num_code": "96",
        "alpha_2_code": "BN",
        "alpha_3_code": "BRN",
        "en_short_name": "Brunei Darussalam",
        "nationality": "Bruneian"
    },
    {
        "num_code": "100",
        "alpha_2_code": "BG",
        "alpha_3_code": "BGR",
        "en_short_name": "Bulgaria",
        "nationality": "Bulgarian"
    },
    {
        "num_code": "854",
        "alpha_2_code": "BF",
        "alpha_3_code": "BFA",
        "en_short_name": "Burkina Faso",
        "nationality": "Burkinab\u00e9"
    },
    {
        "num_code": "108",
        "alpha_2_code": "BI",
        "alpha_3_code": "BDI",
        "en_short_name": "Burundi",
        "nationality": "Burundian"
    },
    {
        "num_code": "132",
        "alpha_2_code": "CV",
        "alpha_3_code": "CPV",
        "en_short_name": "Cabo Verde",
        "nationality": "Cabo Verdean"
    },
    {
        "num_code": "116",
        "alpha_2_code": "KH",
        "alpha_3_code": "KHM",
        "en_short_name": "Cambodia",
        "nationality": "Cambodian"
    },
    {
        "num_code": "120",
        "alpha_2_code": "CM",
        "alpha_3_code": "CMR",
        "en_short_name": "Cameroon",
        "nationality": "Cameroonian"
    },
    {
        "num_code": "124",
        "alpha_2_code": "CA",
        "alpha_3_code": "CAN",
        "en_short_name": "Canada",
        "nationality": "Canadian"
    },
    {
        "num_code": "136",
        "alpha_2_code": "KY",
        "alpha_3_code": "CYM",
        "en_short_name": "Cayman Islands",
        "nationality": "Caymanian"
    },
    {
        "num_code": "140",
        "alpha_2_code": "CF",
        "alpha_3_code": "CAF",
        "en_short_name": "Central African Republic",
        "nationality": "Central African"
    },
    {
        "num_code": "148",
        "alpha_2_code": "TD",
        "alpha_3_code": "TCD",
        "en_short_name": "Chad",
        "nationality": "Chadian"
    },
    {
        "num_code": "152",
        "alpha_2_code": "CL",
        "alpha_3_code": "CHL",
        "en_short_name": "Chile",
        "nationality": "Chilean"
    },
    {
        "num_code": "156",
        "alpha_2_code": "CN",
        "alpha_3_code": "CHN",
        "en_short_name": "China",
        "nationality": "Chinese"
    },
    {
        "num_code": "162",
        "alpha_2_code": "CX",
        "alpha_3_code": "CXR",
        "en_short_name": "Christmas Island",
        "nationality": "Christmas Island"
    },
    {
        "num_code": "166",
        "alpha_2_code": "CC",
        "alpha_3_code": "CCK",
        "en_short_name": "Cocos (Keeling) Islands",
        "nationality": "Cocos Island"
    },
    {
        "num_code": "170",
        "alpha_2_code": "CO",
        "alpha_3_code": "COL",
        "en_short_name": "Colombia",
        "nationality": "Colombian"
    },
    {
        "num_code": "174",
        "alpha_2_code": "KM",
        "alpha_3_code": "COM",
        "en_short_name": "Comoros",
        "nationality": "Comoran, Comorian"
    },
    {
        "num_code": "178",
        "alpha_2_code": "CG",
        "alpha_3_code": "COG",
        "en_short_name": "Congo (Republic of the)",
        "nationality": "Congolese"
    },
    {
        "num_code": "180",
        "alpha_2_code": "CD",
        "alpha_3_code": "COD",
        "en_short_name": "Congo (Democratic Republic of the)",
        "nationality": "Congolese"
    },
    {
        "num_code": "184",
        "alpha_2_code": "CK",
        "alpha_3_code": "COK",
        "en_short_name": "Cook Islands",
        "nationality": "Cook Island"
    },
    {
        "num_code": "188",
        "alpha_2_code": "CR",
        "alpha_3_code": "CRI",
        "en_short_name": "Costa Rica",
        "nationality": "Costa Rican"
    },
    {
        "num_code": "384",
        "alpha_2_code": "CI",
        "alpha_3_code": "CIV",
        "en_short_name": "C\u00f4te d'Ivoire",
        "nationality": "Ivorian"
    },
    {
        "num_code": "191",
        "alpha_2_code": "HR",
        "alpha_3_code": "HRV",
        "en_short_name": "Croatia",
        "nationality": "Croatian"
    },
    {
        "num_code": "192",
        "alpha_2_code": "CU",
        "alpha_3_code": "CUB",
        "en_short_name": "Cuba",
        "nationality": "Cuban"
    },
    {
        "num_code": "531",
        "alpha_2_code": "CW",
        "alpha_3_code": "CUW",
        "en_short_name": "Cura\u00e7ao",
        "nationality": "Cura\u00e7aoan"
    },
    {
        "num_code": "196",
        "alpha_2_code": "CY",
        "alpha_3_code": "CYP",
        "en_short_name": "Cyprus",
        "nationality": "Cypriot"
    },
    {
        "num_code": "203",
        "alpha_2_code": "CZ",
        "alpha_3_code": "CZE",
        "en_short_name": "Czech Republic",
        "nationality": "Czech"
    },
    {
        "num_code": "208",
        "alpha_2_code": "DK",
        "alpha_3_code": "DNK",
        "en_short_name": "Denmark",
        "nationality": "Danish"
    },
    {
        "num_code": "262",
        "alpha_2_code": "DJ",
        "alpha_3_code": "DJI",
        "en_short_name": "Djibouti",
        "nationality": "Djiboutian"
    },
    {
        "num_code": "212",
        "alpha_2_code": "DM",
        "alpha_3_code": "DMA",
        "en_short_name": "Dominica",
        "nationality": "Dominican"
    },
    {
        "num_code": "214",
        "alpha_2_code": "DO",
        "alpha_3_code": "DOM",
        "en_short_name": "Dominican Republic",
        "nationality": "Dominican"
    },
    {
        "num_code": "218",
        "alpha_2_code": "EC",
        "alpha_3_code": "ECU",
        "en_short_name": "Ecuador",
        "nationality": "Ecuadorian"
    },
    {
        "num_code": "818",
        "alpha_2_code": "EG",
        "alpha_3_code": "EGY",
        "en_short_name": "Egypt",
        "nationality": "Egyptian"
    },
    {
        "num_code": "222",
        "alpha_2_code": "SV",
        "alpha_3_code": "SLV",
        "en_short_name": "El Salvador",
        "nationality": "Salvadoran"
    },
    {
        "num_code": "226",
        "alpha_2_code": "GQ",
        "alpha_3_code": "GNQ",
        "en_short_name": "Equatorial Guinea",
        "nationality": "Equatorial Guinean, Equatoguinean"
    },
    {
        "num_code": "232",
        "alpha_2_code": "ER",
        "alpha_3_code": "ERI",
        "en_short_name": "Eritrea",
        "nationality": "Eritrean"
    },
    {
        "num_code": "233",
        "alpha_2_code": "EE",
        "alpha_3_code": "EST",
        "en_short_name": "Estonia",
        "nationality": "Estonian"
    },
    {
        "num_code": "231",
        "alpha_2_code": "ET",
        "alpha_3_code": "ETH",
        "en_short_name": "Ethiopia",
        "nationality": "Ethiopian"
    },
    {
        "num_code": "238",
        "alpha_2_code": "FK",
        "alpha_3_code": "FLK",
        "en_short_name": "Falkland Islands (Malvinas)",
        "nationality": "Falkland Island"
    },
    {
        "num_code": "234",
        "alpha_2_code": "FO",
        "alpha_3_code": "FRO",
        "en_short_name": "Faroe Islands",
        "nationality": "Faroese"
    },
    {
        "num_code": "242",
        "alpha_2_code": "FJ",
        "alpha_3_code": "FJI",
        "en_short_name": "Fiji",
        "nationality": "Fijian"
    },
    {
        "num_code": "246",
        "alpha_2_code": "FI",
        "alpha_3_code": "FIN",
        "en_short_name": "Finland",
        "nationality": "Finnish"
    },
    {
        "num_code": "250",
        "alpha_2_code": "FR",
        "alpha_3_code": "FRA",
        "en_short_name": "France",
        "nationality": "French"
    },
    {
        "num_code": "254",
        "alpha_2_code": "GF",
        "alpha_3_code": "GUF",
        "en_short_name": "French Guiana",
        "nationality": "French Guianese"
    },
    {
        "num_code": "258",
        "alpha_2_code": "PF",
        "alpha_3_code": "PYF",
        "en_short_name": "French Polynesia",
        "nationality": "French Polynesian"
    },
    {
        "num_code": "260",
        "alpha_2_code": "TF",
        "alpha_3_code": "ATF",
        "en_short_name": "French Southern Territories",
        "nationality": "French Southern Territories"
    },
    {
        "num_code": "266",
        "alpha_2_code": "GA",
        "alpha_3_code": "GAB",
        "en_short_name": "Gabon",
        "nationality": "Gabonese"
    },
    {
        "num_code": "270",
        "alpha_2_code": "GM",
        "alpha_3_code": "GMB",
        "en_short_name": "Gambia",
        "nationality": "Gambian"
    },
    {
        "num_code": "268",
        "alpha_2_code": "GE",
        "alpha_3_code": "GEO",
        "en_short_name": "Georgia",
        "nationality": "Georgian"
    },
    {
        "num_code": "276",
        "alpha_2_code": "DE",
        "alpha_3_code": "DEU",
        "en_short_name": "Germany",
        "nationality": "German"
    },
    {
        "num_code": "288",
        "alpha_2_code": "GH",
        "alpha_3_code": "GHA",
        "en_short_name": "Ghana",
        "nationality": "Ghanaian"
    },
    {
        "num_code": "292",
        "alpha_2_code": "GI",
        "alpha_3_code": "GIB",
        "en_short_name": "Gibraltar",
        "nationality": "Gibraltar"
    },
    {
        "num_code": "300",
        "alpha_2_code": "GR",
        "alpha_3_code": "GRC",
        "en_short_name": "Greece",
        "nationality": "Greek, Hellenic"
    },
    {
        "num_code": "304",
        "alpha_2_code": "GL",
        "alpha_3_code": "GRL",
        "en_short_name": "Greenland",
        "nationality": "Greenlandic"
    },
    {
        "num_code": "308",
        "alpha_2_code": "GD",
        "alpha_3_code": "GRD",
        "en_short_name": "Grenada",
        "nationality": "Grenadian"
    },
    {
        "num_code": "312",
        "alpha_2_code": "GP",
        "alpha_3_code": "GLP",
        "en_short_name": "Guadeloupe",
        "nationality": "Guadeloupe"
    },
    {
        "num_code": "316",
        "alpha_2_code": "GU",
        "alpha_3_code": "GUM",
        "en_short_name": "Guam",
        "nationality": "Guamanian, Guambat"
    },
    {
        "num_code": "320",
        "alpha_2_code": "GT",
        "alpha_3_code": "GTM",
        "en_short_name": "Guatemala",
        "nationality": "Guatemalan"
    },
    {
        "num_code": "831",
        "alpha_2_code": "GG",
        "alpha_3_code": "GGY",
        "en_short_name": "Guernsey",
        "nationality": "Channel Island"
    },
    {
        "num_code": "324",
        "alpha_2_code": "GN",
        "alpha_3_code": "GIN",
        "en_short_name": "Guinea",
        "nationality": "Guinean"
    },
    {
        "num_code": "624",
        "alpha_2_code": "GW",
        "alpha_3_code": "GNB",
        "en_short_name": "Guinea-Bissau",
        "nationality": "Bissau-Guinean"
    },
    {
        "num_code": "328",
        "alpha_2_code": "GY",
        "alpha_3_code": "GUY",
        "en_short_name": "Guyana",
        "nationality": "Guyanese"
    },
    {
        "num_code": "332",
        "alpha_2_code": "HT",
        "alpha_3_code": "HTI",
        "en_short_name": "Haiti",
        "nationality": "Haitian"
    },
    {
        "num_code": "334",
        "alpha_2_code": "HM",
        "alpha_3_code": "HMD",
        "en_short_name": "Heard Island and McDonald Islands",
        "nationality": "Heard Island or McDonald Islands"
    },
    {
        "num_code": "336",
        "alpha_2_code": "VA",
        "alpha_3_code": "VAT",
        "en_short_name": "Vatican City State",
        "nationality": "Vatican"
    },
    {
        "num_code": "340",
        "alpha_2_code": "HN",
        "alpha_3_code": "HND",
        "en_short_name": "Honduras",
        "nationality": "Honduran"
    },
    {
        "num_code": "344",
        "alpha_2_code": "HK",
        "alpha_3_code": "HKG",
        "en_short_name": "Hong Kong",
        "nationality": "Hong Kong, Hong Kongese"
    },
    {
        "num_code": "348",
        "alpha_2_code": "HU",
        "alpha_3_code": "HUN",
        "en_short_name": "Hungary",
        "nationality": "Hungarian, Magyar"
    },
    {
        "num_code": "352",
        "alpha_2_code": "IS",
        "alpha_3_code": "ISL",
        "en_short_name": "Iceland",
        "nationality": "Icelandic"
    },
    {
        "num_code": "356",
        "alpha_2_code": "IN",
        "alpha_3_code": "IND",
        "en_short_name": "India",
        "nationality": "Indian"
    },
    {
        "num_code": "360",
        "alpha_2_code": "ID",
        "alpha_3_code": "IDN",
        "en_short_name": "Indonesia",
        "nationality": "Indonesian"
    },
    {
        "num_code": "364",
        "alpha_2_code": "IR",
        "alpha_3_code": "IRN",
        "en_short_name": "Iran",
        "nationality": "Iranian, Persian"
    },
    {
        "num_code": "368",
        "alpha_2_code": "IQ",
        "alpha_3_code": "IRQ",
        "en_short_name": "Iraq",
        "nationality": "Iraqi"
    },
    {
        "num_code": "372",
        "alpha_2_code": "IE",
        "alpha_3_code": "IRL",
        "en_short_name": "Ireland",
        "nationality": "Irish"
    },
    {
        "num_code": "833",
        "alpha_2_code": "IM",
        "alpha_3_code": "IMN",
        "en_short_name": "Isle of Man",
        "nationality": "Manx"
    },
    {
        "num_code": "376",
        "alpha_2_code": "IL",
        "alpha_3_code": "ISR",
        "en_short_name": "Israel",
        "nationality": "Israeli"
    },
    {
        "num_code": "380",
        "alpha_2_code": "IT",
        "alpha_3_code": "ITA",
        "en_short_name": "Italy",
        "nationality": "Italian"
    },
    {
        "num_code": "388",
        "alpha_2_code": "JM",
        "alpha_3_code": "JAM",
        "en_short_name": "Jamaica",
        "nationality": "Jamaican"
    },
    {
        "num_code": "392",
        "alpha_2_code": "JP",
        "alpha_3_code": "JPN",
        "en_short_name": "Japan",
        "nationality": "Japanese"
    },
    {
        "num_code": "832",
        "alpha_2_code": "JE",
        "alpha_3_code": "JEY",
        "en_short_name": "Jersey",
        "nationality": "Channel Island"
    },
    {
        "num_code": "400",
        "alpha_2_code": "JO",
        "alpha_3_code": "JOR",
        "en_short_name": "Jordan",
        "nationality": "Jordanian"
    },
    {
        "num_code": "398",
        "alpha_2_code": "KZ",
        "alpha_3_code": "KAZ",
        "en_short_name": "Kazakhstan",
        "nationality": "Kazakhstani, Kazakh"
    },
    {
        "num_code": "404",
        "alpha_2_code": "KE",
        "alpha_3_code": "KEN",
        "en_short_name": "Kenya",
        "nationality": "Kenyan"
    },
    {
        "num_code": "296",
        "alpha_2_code": "KI",
        "alpha_3_code": "KIR",
        "en_short_name": "Kiribati",
        "nationality": "I-Kiribati"
    },
    {
        "num_code": "408",
        "alpha_2_code": "KP",
        "alpha_3_code": "PRK",
        "en_short_name": "Korea (Democratic People's Republic of)",
        "nationality": "North Korean"
    },
    {
        "num_code": "410",
        "alpha_2_code": "KR",
        "alpha_3_code": "KOR",
        "en_short_name": "Korea (Republic of)",
        "nationality": "South Korean"
    },
    {
        "num_code": "414",
        "alpha_2_code": "KW",
        "alpha_3_code": "KWT",
        "en_short_name": "Kuwait",
        "nationality": "Kuwaiti"
    },
    {
        "num_code": "417",
        "alpha_2_code": "KG",
        "alpha_3_code": "KGZ",
        "en_short_name": "Kyrgyzstan",
        "nationality": "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"
    },
    {
        "num_code": "418",
        "alpha_2_code": "LA",
        "alpha_3_code": "LAO",
        "en_short_name": "Lao People's Democratic Republic",
        "nationality": "Lao, Laotian"
    },
    {
        "num_code": "428",
        "alpha_2_code": "LV",
        "alpha_3_code": "LVA",
        "en_short_name": "Latvia",
        "nationality": "Latvian"
    },
    {
        "num_code": "422",
        "alpha_2_code": "LB",
        "alpha_3_code": "LBN",
        "en_short_name": "Lebanon",
        "nationality": "Lebanese"
    },
    {
        "num_code": "426",
        "alpha_2_code": "LS",
        "alpha_3_code": "LSO",
        "en_short_name": "Lesotho",
        "nationality": "Basotho"
    },
    {
        "num_code": "430",
        "alpha_2_code": "LR",
        "alpha_3_code": "LBR",
        "en_short_name": "Liberia",
        "nationality": "Liberian"
    },
    {
        "num_code": "434",
        "alpha_2_code": "LY",
        "alpha_3_code": "LBY",
        "en_short_name": "Libya",
        "nationality": "Libyan"
    },
    {
        "num_code": "438",
        "alpha_2_code": "LI",
        "alpha_3_code": "LIE",
        "en_short_name": "Liechtenstein",
        "nationality": "Liechtenstein"
    },
    {
        "num_code": "440",
        "alpha_2_code": "LT",
        "alpha_3_code": "LTU",
        "en_short_name": "Lithuania",
        "nationality": "Lithuanian"
    },
    {
        "num_code": "442",
        "alpha_2_code": "LU",
        "alpha_3_code": "LUX",
        "en_short_name": "Luxembourg",
        "nationality": "Luxembourg, Luxembourgish"
    },
    {
        "num_code": "446",
        "alpha_2_code": "MO",
        "alpha_3_code": "MAC",
        "en_short_name": "Macao",
        "nationality": "Macanese, Chinese"
    },
    {
        "num_code": "807",
        "alpha_2_code": "MK",
        "alpha_3_code": "MKD",
        "en_short_name": "Macedonia (the former Yugoslav Republic of)",
        "nationality": "Macedonian"
    },
    {
        "num_code": "450",
        "alpha_2_code": "MG",
        "alpha_3_code": "MDG",
        "en_short_name": "Madagascar",
        "nationality": "Malagasy"
    },
    {
        "num_code": "454",
        "alpha_2_code": "MW",
        "alpha_3_code": "MWI",
        "en_short_name": "Malawi",
        "nationality": "Malawian"
    },
    {
        "num_code": "458",
        "alpha_2_code": "MY",
        "alpha_3_code": "MYS",
        "en_short_name": "Malaysia",
        "nationality": "Malaysian"
    },
    {
        "num_code": "462",
        "alpha_2_code": "MV",
        "alpha_3_code": "MDV",
        "en_short_name": "Maldives",
        "nationality": "Maldivian"
    },
    {
        "num_code": "466",
        "alpha_2_code": "ML",
        "alpha_3_code": "MLI",
        "en_short_name": "Mali",
        "nationality": "Malian, Malinese"
    },
    {
        "num_code": "470",
        "alpha_2_code": "MT",
        "alpha_3_code": "MLT",
        "en_short_name": "Malta",
        "nationality": "Maltese"
    },
    {
        "num_code": "584",
        "alpha_2_code": "MH",
        "alpha_3_code": "MHL",
        "en_short_name": "Marshall Islands",
        "nationality": "Marshallese"
    },
    {
        "num_code": "474",
        "alpha_2_code": "MQ",
        "alpha_3_code": "MTQ",
        "en_short_name": "Martinique",
        "nationality": "Martiniquais, Martinican"
    },
    {
        "num_code": "478",
        "alpha_2_code": "MR",
        "alpha_3_code": "MRT",
        "en_short_name": "Mauritania",
        "nationality": "Mauritanian"
    },
    {
        "num_code": "480",
        "alpha_2_code": "MU",
        "alpha_3_code": "MUS",
        "en_short_name": "Mauritius",
        "nationality": "Mauritian"
    },
    {
        "num_code": "175",
        "alpha_2_code": "YT",
        "alpha_3_code": "MYT",
        "en_short_name": "Mayotte",
        "nationality": "Mahoran"
    },
    {
        "num_code": "484",
        "alpha_2_code": "MX",
        "alpha_3_code": "MEX",
        "en_short_name": "Mexico",
        "nationality": "Mexican"
    },
    {
        "num_code": "583",
        "alpha_2_code": "FM",
        "alpha_3_code": "FSM",
        "en_short_name": "Micronesia (Federated States of)",
        "nationality": "Micronesian"
    },
    {
        "num_code": "498",
        "alpha_2_code": "MD",
        "alpha_3_code": "MDA",
        "en_short_name": "Moldova (Republic of)",
        "nationality": "Moldovan"
    },
    {
        "num_code": "492",
        "alpha_2_code": "MC",
        "alpha_3_code": "MCO",
        "en_short_name": "Monaco",
        "nationality": "Mon\u00e9gasque, Monacan"
    },
    {
        "num_code": "496",
        "alpha_2_code": "MN",
        "alpha_3_code": "MNG",
        "en_short_name": "Mongolia",
        "nationality": "Mongolian"
    },
    {
        "num_code": "499",
        "alpha_2_code": "ME",
        "alpha_3_code": "MNE",
        "en_short_name": "Montenegro",
        "nationality": "Montenegrin"
    },
    {
        "num_code": "500",
        "alpha_2_code": "MS",
        "alpha_3_code": "MSR",
        "en_short_name": "Montserrat",
        "nationality": "Montserratian"
    },
    {
        "num_code": "504",
        "alpha_2_code": "MA",
        "alpha_3_code": "MAR",
        "en_short_name": "Morocco",
        "nationality": "Moroccan"
    },
    {
        "num_code": "508",
        "alpha_2_code": "MZ",
        "alpha_3_code": "MOZ",
        "en_short_name": "Mozambique",
        "nationality": "Mozambican"
    },
    {
        "num_code": "104",
        "alpha_2_code": "MM",
        "alpha_3_code": "MMR",
        "en_short_name": "Myanmar",
        "nationality": "Burmese"
    },
    {
        "num_code": "516",
        "alpha_2_code": "NA",
        "alpha_3_code": "NAM",
        "en_short_name": "Namibia",
        "nationality": "Namibian"
    },
    {
        "num_code": "520",
        "alpha_2_code": "NR",
        "alpha_3_code": "NRU",
        "en_short_name": "Nauru",
        "nationality": "Nauruan"
    },
    {
        "num_code": "524",
        "alpha_2_code": "NP",
        "alpha_3_code": "NPL",
        "en_short_name": "Nepal",
        "nationality": "Nepali, Nepalese"
    },
    {
        "num_code": "528",
        "alpha_2_code": "NL",
        "alpha_3_code": "NLD",
        "en_short_name": "Netherlands",
        "nationality": "Dutch, Netherlandic"
    },
    {
        "num_code": "540",
        "alpha_2_code": "NC",
        "alpha_3_code": "NCL",
        "en_short_name": "New Caledonia",
        "nationality": "New Caledonian"
    },
    {
        "num_code": "554",
        "alpha_2_code": "NZ",
        "alpha_3_code": "NZL",
        "en_short_name": "New Zealand",
        "nationality": "New Zealand, NZ"
    },
    {
        "num_code": "558",
        "alpha_2_code": "NI",
        "alpha_3_code": "NIC",
        "en_short_name": "Nicaragua",
        "nationality": "Nicaraguan"
    },
    {
        "num_code": "562",
        "alpha_2_code": "NE",
        "alpha_3_code": "NER",
        "en_short_name": "Niger",
        "nationality": "Nigerien"
    },
    {
        "num_code": "566",
        "alpha_2_code": "NG",
        "alpha_3_code": "NGA",
        "en_short_name": "Nigeria",
        "nationality": "Nigerian"
    },
    {
        "num_code": "570",
        "alpha_2_code": "NU",
        "alpha_3_code": "NIU",
        "en_short_name": "Niue",
        "nationality": "Niuean"
    },
    {
        "num_code": "574",
        "alpha_2_code": "NF",
        "alpha_3_code": "NFK",
        "en_short_name": "Norfolk Island",
        "nationality": "Norfolk Island"
    },
    {
        "num_code": "580",
        "alpha_2_code": "MP",
        "alpha_3_code": "MNP",
        "en_short_name": "Northern Mariana Islands",
        "nationality": "Northern Marianan"
    },
    {
        "num_code": "578",
        "alpha_2_code": "NO",
        "alpha_3_code": "NOR",
        "en_short_name": "Norway",
        "nationality": "Norwegian"
    },
    {
        "num_code": "512",
        "alpha_2_code": "OM",
        "alpha_3_code": "OMN",
        "en_short_name": "Oman",
        "nationality": "Omani"
    },
    {
        "num_code": "586",
        "alpha_2_code": "PK",
        "alpha_3_code": "PAK",
        "en_short_name": "Pakistan",
        "nationality": "Pakistani"
    },
    {
        "num_code": "585",
        "alpha_2_code": "PW",
        "alpha_3_code": "PLW",
        "en_short_name": "Palau",
        "nationality": "Palauan"
    },
    {
        "num_code": "275",
        "alpha_2_code": "PS",
        "alpha_3_code": "PSE",
        "en_short_name": "Palestine, State of",
        "nationality": "Palestinian"
    },
    {
        "num_code": "591",
        "alpha_2_code": "PA",
        "alpha_3_code": "PAN",
        "en_short_name": "Panama",
        "nationality": "Panamanian"
    },
    {
        "num_code": "598",
        "alpha_2_code": "PG",
        "alpha_3_code": "PNG",
        "en_short_name": "Papua New Guinea",
        "nationality": "Papua New Guinean, Papuan"
    },
    {
        "num_code": "600",
        "alpha_2_code": "PY",
        "alpha_3_code": "PRY",
        "en_short_name": "Paraguay",
        "nationality": "Paraguayan"
    },
    {
        "num_code": "604",
        "alpha_2_code": "PE",
        "alpha_3_code": "PER",
        "en_short_name": "Peru",
        "nationality": "Peruvian"
    },
    {
        "num_code": "608",
        "alpha_2_code": "PH",
        "alpha_3_code": "PHL",
        "en_short_name": "Philippines",
        "nationality": "Philippine, Filipino"
    },
    {
        "num_code": "612",
        "alpha_2_code": "PN",
        "alpha_3_code": "PCN",
        "en_short_name": "Pitcairn",
        "nationality": "Pitcairn Island"
    },
    {
        "num_code": "616",
        "alpha_2_code": "PL",
        "alpha_3_code": "POL",
        "en_short_name": "Poland",
        "nationality": "Polish"
    },
    {
        "num_code": "620",
        "alpha_2_code": "PT",
        "alpha_3_code": "PRT",
        "en_short_name": "Portugal",
        "nationality": "Portuguese"
    },
    {
        "num_code": "630",
        "alpha_2_code": "PR",
        "alpha_3_code": "PRI",
        "en_short_name": "Puerto Rico",
        "nationality": "Puerto Rican"
    },
    {
        "num_code": "634",
        "alpha_2_code": "QA",
        "alpha_3_code": "QAT",
        "en_short_name": "Qatar",
        "nationality": "Qatari"
    },
    {
        "num_code": "638",
        "alpha_2_code": "RE",
        "alpha_3_code": "REU",
        "en_short_name": "R\u00e9union",
        "nationality": "R\u00e9unionese, R\u00e9unionnais"
    },
    {
        "num_code": "642",
        "alpha_2_code": "RO",
        "alpha_3_code": "ROU",
        "en_short_name": "Romania",
        "nationality": "Romanian"
    },
    {
        "num_code": "643",
        "alpha_2_code": "RU",
        "alpha_3_code": "RUS",
        "en_short_name": "Russian Federation",
        "nationality": "Russian"
    },
    {
        "num_code": "646",
        "alpha_2_code": "RW",
        "alpha_3_code": "RWA",
        "en_short_name": "Rwanda",
        "nationality": "Rwandan"
    },
    {
        "num_code": "652",
        "alpha_2_code": "BL",
        "alpha_3_code": "BLM",
        "en_short_name": "Saint Barth\u00e9lemy",
        "nationality": "Barth\u00e9lemois"
    },
    {
        "num_code": "654",
        "alpha_2_code": "SH",
        "alpha_3_code": "SHN",
        "en_short_name": "Saint Helena, Ascension and Tristan da Cunha",
        "nationality": "Saint Helenian"
    },
    {
        "num_code": "659",
        "alpha_2_code": "KN",
        "alpha_3_code": "KNA",
        "en_short_name": "Saint Kitts and Nevis",
        "nationality": "Kittitian or Nevisian"
    },
    {
        "num_code": "662",
        "alpha_2_code": "LC",
        "alpha_3_code": "LCA",
        "en_short_name": "Saint Lucia",
        "nationality": "Saint Lucian"
    },
    {
        "num_code": "663",
        "alpha_2_code": "MF",
        "alpha_3_code": "MAF",
        "en_short_name": "Saint Martin (French part)",
        "nationality": "Saint-Martinoise"
    },
    {
        "num_code": "666",
        "alpha_2_code": "PM",
        "alpha_3_code": "SPM",
        "en_short_name": "Saint Pierre and Miquelon",
        "nationality": "Saint-Pierrais or Miquelonnais"
    },
    {
        "num_code": "670",
        "alpha_2_code": "VC",
        "alpha_3_code": "VCT",
        "en_short_name": "Saint Vincent and the Grenadines",
        "nationality": "Saint Vincentian, Vincentian"
    },
    {
        "num_code": "882",
        "alpha_2_code": "WS",
        "alpha_3_code": "WSM",
        "en_short_name": "Samoa",
        "nationality": "Samoan"
    },
    {
        "num_code": "674",
        "alpha_2_code": "SM",
        "alpha_3_code": "SMR",
        "en_short_name": "San Marino",
        "nationality": "Sammarinese"
    },
    {
        "num_code": "678",
        "alpha_2_code": "ST",
        "alpha_3_code": "STP",
        "en_short_name": "Sao Tome and Principe",
        "nationality": "S\u00e3o Tom\u00e9an"
    },
    {
        "num_code": "682",
        "alpha_2_code": "SA",
        "alpha_3_code": "SAU",
        "en_short_name": "Saudi Arabia",
        "nationality": "Saudi, Saudi Arabian"
    },
    {
        "num_code": "686",
        "alpha_2_code": "SN",
        "alpha_3_code": "SEN",
        "en_short_name": "Senegal",
        "nationality": "Senegalese"
    },
    {
        "num_code": "688",
        "alpha_2_code": "RS",
        "alpha_3_code": "SRB",
        "en_short_name": "Serbia",
        "nationality": "Serbian"
    },
    {
        "num_code": "690",
        "alpha_2_code": "SC",
        "alpha_3_code": "SYC",
        "en_short_name": "Seychelles",
        "nationality": "Seychellois"
    },
    {
        "num_code": "694",
        "alpha_2_code": "SL",
        "alpha_3_code": "SLE",
        "en_short_name": "Sierra Leone",
        "nationality": "Sierra Leonean"
    },
    {
        "num_code": "702",
        "alpha_2_code": "SG",
        "alpha_3_code": "SGP",
        "en_short_name": "Singapore",
        "nationality": "Singaporean"
    },
    {
        "num_code": "534",
        "alpha_2_code": "SX",
        "alpha_3_code": "SXM",
        "en_short_name": "Sint Maarten (Dutch part)",
        "nationality": "Sint Maarten"
    },
    {
        "num_code": "703",
        "alpha_2_code": "SK",
        "alpha_3_code": "SVK",
        "en_short_name": "Slovakia",
        "nationality": "Slovak"
    },
    {
        "num_code": "705",
        "alpha_2_code": "SI",
        "alpha_3_code": "SVN",
        "en_short_name": "Slovenia",
        "nationality": "Slovenian, Slovene"
    },
    {
        "num_code": "90",
        "alpha_2_code": "SB",
        "alpha_3_code": "SLB",
        "en_short_name": "Solomon Islands",
        "nationality": "Solomon Island"
    },
    {
        "num_code": "706",
        "alpha_2_code": "SO",
        "alpha_3_code": "SOM",
        "en_short_name": "Somalia",
        "nationality": "Somali, Somalian"
    },
    {
        "num_code": "710",
        "alpha_2_code": "ZA",
        "alpha_3_code": "ZAF",
        "en_short_name": "South Africa",
        "nationality": "South African"
    },
    {
        "num_code": "239",
        "alpha_2_code": "GS",
        "alpha_3_code": "SGS",
        "en_short_name": "South Georgia and the South Sandwich Islands",
        "nationality": "South Georgia or South Sandwich Islands"
    },
    {
        "num_code": "728",
        "alpha_2_code": "SS",
        "alpha_3_code": "SSD",
        "en_short_name": "South Sudan",
        "nationality": "South Sudanese"
    },
    {
        "num_code": "724",
        "alpha_2_code": "ES",
        "alpha_3_code": "ESP",
        "en_short_name": "Spain",
        "nationality": "Spanish"
    },
    {
        "num_code": "144",
        "alpha_2_code": "LK",
        "alpha_3_code": "LKA",
        "en_short_name": "Sri Lanka",
        "nationality": "Sri Lankan"
    },
    {
        "num_code": "729",
        "alpha_2_code": "SD",
        "alpha_3_code": "SDN",
        "en_short_name": "Sudan",
        "nationality": "Sudanese"
    },
    {
        "num_code": "740",
        "alpha_2_code": "SR",
        "alpha_3_code": "SUR",
        "en_short_name": "Suriname",
        "nationality": "Surinamese"
    },
    {
        "num_code": "744",
        "alpha_2_code": "SJ",
        "alpha_3_code": "SJM",
        "en_short_name": "Svalbard and Jan Mayen",
        "nationality": "Svalbard"
    },
    {
        "num_code": "748",
        "alpha_2_code": "SZ",
        "alpha_3_code": "SWZ",
        "en_short_name": "Swaziland",
        "nationality": "Swazi"
    },
    {
        "num_code": "752",
        "alpha_2_code": "SE",
        "alpha_3_code": "SWE",
        "en_short_name": "Sweden",
        "nationality": "Swedish"
    },
    {
        "num_code": "756",
        "alpha_2_code": "CH",
        "alpha_3_code": "CHE",
        "en_short_name": "Switzerland",
        "nationality": "Swiss"
    },
    {
        "num_code": "760",
        "alpha_2_code": "SY",
        "alpha_3_code": "SYR",
        "en_short_name": "Syrian Arab Republic",
        "nationality": "Syrian"
    },
    {
        "num_code": "158",
        "alpha_2_code": "TW",
        "alpha_3_code": "TWN",
        "en_short_name": "Taiwan, Province of China",
        "nationality": "Chinese, Taiwanese"
    },
    {
        "num_code": "762",
        "alpha_2_code": "TJ",
        "alpha_3_code": "TJK",
        "en_short_name": "Tajikistan",
        "nationality": "Tajikistani"
    },
    {
        "num_code": "834",
        "alpha_2_code": "TZ",
        "alpha_3_code": "TZA",
        "en_short_name": "Tanzania, United Republic of",
        "nationality": "Tanzanian"
    },
    {
        "num_code": "764",
        "alpha_2_code": "TH",
        "alpha_3_code": "THA",
        "en_short_name": "Thailand",
        "nationality": "Thai"
    },
    {
        "num_code": "626",
        "alpha_2_code": "TL",
        "alpha_3_code": "TLS",
        "en_short_name": "Timor-Leste",
        "nationality": "Timorese"
    },
    {
        "num_code": "768",
        "alpha_2_code": "TG",
        "alpha_3_code": "TGO",
        "en_short_name": "Togo",
        "nationality": "Togolese"
    },
    {
        "num_code": "772",
        "alpha_2_code": "TK",
        "alpha_3_code": "TKL",
        "en_short_name": "Tokelau",
        "nationality": "Tokelauan"
    },
    {
        "num_code": "776",
        "alpha_2_code": "TO",
        "alpha_3_code": "TON",
        "en_short_name": "Tonga",
        "nationality": "Tongan"
    },
    {
        "num_code": "780",
        "alpha_2_code": "TT",
        "alpha_3_code": "TTO",
        "en_short_name": "Trinidad and Tobago",
        "nationality": "Trinidadian or Tobagonian"
    },
    {
        "num_code": "788",
        "alpha_2_code": "TN",
        "alpha_3_code": "TUN",
        "en_short_name": "Tunisia",
        "nationality": "Tunisian"
    },
    {
        "num_code": "792",
        "alpha_2_code": "TR",
        "alpha_3_code": "TUR",
        "en_short_name": "Turkey",
        "nationality": "Turkish"
    },
    {
        "num_code": "795",
        "alpha_2_code": "TM",
        "alpha_3_code": "TKM",
        "en_short_name": "Turkmenistan",
        "nationality": "Turkmen"
    },
    {
        "num_code": "796",
        "alpha_2_code": "TC",
        "alpha_3_code": "TCA",
        "en_short_name": "Turks and Caicos Islands",
        "nationality": "Turks and Caicos Island"
    },
    {
        "num_code": "798",
        "alpha_2_code": "TV",
        "alpha_3_code": "TUV",
        "en_short_name": "Tuvalu",
        "nationality": "Tuvaluan"
    },
    {
        "num_code": "800",
        "alpha_2_code": "UG",
        "alpha_3_code": "UGA",
        "en_short_name": "Uganda",
        "nationality": "Ugandan"
    },
    {
        "num_code": "804",
        "alpha_2_code": "UA",
        "alpha_3_code": "UKR",
        "en_short_name": "Ukraine",
        "nationality": "Ukrainian"
    },
    {
        "num_code": "784",
        "alpha_2_code": "AE",
        "alpha_3_code": "ARE",
        "en_short_name": "United Arab Emirates",
        "nationality": "Emirati, Emirian, Emiri"
    },
    {
        "num_code": "826",
        "alpha_2_code": "GB",
        "alpha_3_code": "GBR",
        "en_short_name": "United Kingdom of Great Britain and Northern Ireland",
        "nationality": "British, UK"
    },
    {
        "num_code": "581",
        "alpha_2_code": "UM",
        "alpha_3_code": "UMI",
        "en_short_name": "United States Minor Outlying Islands",
        "nationality": "American"
    },
    {
        "num_code": "840",
        "alpha_2_code": "US",
        "alpha_3_code": "USA",
        "en_short_name": "United States of America",
        "nationality": "American"
    },
    {
        "num_code": "858",
        "alpha_2_code": "UY",
        "alpha_3_code": "URY",
        "en_short_name": "Uruguay",
        "nationality": "Uruguayan"
    },
    {
        "num_code": "860",
        "alpha_2_code": "UZ",
        "alpha_3_code": "UZB",
        "en_short_name": "Uzbekistan",
        "nationality": "Uzbekistani, Uzbek"
    },
    {
        "num_code": "548",
        "alpha_2_code": "VU",
        "alpha_3_code": "VUT",
        "en_short_name": "Vanuatu",
        "nationality": "Ni-Vanuatu, Vanuatuan"
    },
    {
        "num_code": "862",
        "alpha_2_code": "VE",
        "alpha_3_code": "VEN",
        "en_short_name": "Venezuela (Bolivarian Republic of)",
        "nationality": "Venezuelan"
    },
    {
        "num_code": "704",
        "alpha_2_code": "VN",
        "alpha_3_code": "VNM",
        "en_short_name": "Vietnam",
        "nationality": "Vietnamese"
    },
    {
        "num_code": "92",
        "alpha_2_code": "VG",
        "alpha_3_code": "VGB",
        "en_short_name": "Virgin Islands (British)",
        "nationality": "British Virgin Island"
    },
    {
        "num_code": "850",
        "alpha_2_code": "VI",
        "alpha_3_code": "VIR",
        "en_short_name": "Virgin Islands (U.S.)",
        "nationality": "U.S. Virgin Island"
    },
    {
        "num_code": "876",
        "alpha_2_code": "WF",
        "alpha_3_code": "WLF",
        "en_short_name": "Wallis and Futuna",
        "nationality": "Wallis and Futuna, Wallisian or Futunan"
    },
    {
        "num_code": "732",
        "alpha_2_code": "EH",
        "alpha_3_code": "ESH",
        "en_short_name": "Western Sahara",
        "nationality": "Sahrawi, Sahrawian, Sahraouian"
    },
    {
        "num_code": "887",
        "alpha_2_code": "YE",
        "alpha_3_code": "YEM",
        "en_short_name": "Yemen",
        "nationality": "Yemeni"
    },
    {
        "num_code": "894",
        "alpha_2_code": "ZM",
        "alpha_3_code": "ZMB",
        "en_short_name": "Zambia",
        "nationality": "Zambian"
    },
    {
        "num_code": "716",
        "alpha_2_code": "ZW",
        "alpha_3_code": "ZWE",
        "en_short_name": "Zimbabwe",
        "nationality": "Zimbabwean"
    }
];

export const categoryData = [
  {
    "id": 1,
    "category": "Archives Catalogue",
    "subCategory": "Diaries of Persons"
  },
  {
    "id": 2,
    "category": "Archives Catalogue",
    "subCategory": "Bishops' Letters and Documents"
  },
  {
    "id": 3,
    "category": "Archives Catalogue",
    "subCategory": "Caritas"
  },
  {
    "id": 4,
    "category": "Archives Catalogue",
    "subCategory": "Goa"
  },
  {
    "id": 5,
    "category": "Archives Catalogue",
    "subCategory": "Goa"
  },
  {
    "id": 6,
    "category": "Archives Catalogue",
    "subCategory": "Immaculate Conception"
  },
  {
    "id": 7,
    "category": "Archives Catalogue",
    "subCategory": "Jesuit Publications"
  },
  {
    "id": 8,
    "category": "Archives Catalogue",
    "subCategory": "Kodaikanal"
  },
  {
    "id": 9,
    "category": "Archives Catalogue",
    "subCategory": "Malabar Province"
  },
  {
    "id": 10,
    "category": "Archives Catalogue",
    "subCategory": "Manuscripts"
  },
  {
    "id": 11,
    "category": "Archives Catalogue",
    "subCategory": "New Madurai Mission"
  },
  {
    "id": 12,
    "category": "Archives Catalogue",
    "subCategory": "New Madurai Mission Letters"
  },
  {
    "id": 13,
    "category": "Archives Catalogue",
    "subCategory": "Old Madurai Mission Letters"
  },
  {
    "id": 14,
    "category": "Archives Catalogue",
    "subCategory": "PALMERA"
  },
  {
    "id": 15,
    "category": "Archives Catalogue",
    "subCategory": "Parish Diaries"
  },
  {
    "id": 16,
    "category": "Archives Catalogue",
    "subCategory": "Parishes Files"
  },
  {
    "id": 17,
    "category": "Archives Catalogue",
    "subCategory": "Religious Orders (Tamil)"
  },
  {
    "id": 18,
    "category": "Archives Catalogue",
    "subCategory": "Reviews Jesuites"
  },
  {
    "id": 19,
    "category": "Archives Catalogue",
    "subCategory": "Sacred Heart Brothers"
  },
  {
    "id": 20,
    "category": "Archives Catalogue",
    "subCategory": "Sale Deeds Documents and Records"
  },
  {
    "id": 21,
    "category": "Archives Catalogue",
    "subCategory": "Shenbaganur - Kodaikanal"
  },
  {
    "id": 22,
    "category": "Archives Catalogue",
    "subCategory": "St.Anne's - Chennai"
  },
  {
    "id": 23,
    "category": "Archives Catalogue",
    "subCategory": "St.Anne's - Trichy"
  },
  {
    "id": 24,
    "category": "Archives Catalogue",
    "subCategory": "Syrian Christians"
  },
  {
    "id": 25,
    "category": "Archives Catalogue",
    "subCategory": "Tamil Manuscripts"
  },
  {
    "id": 26,
    "category": "Archives Catalogue",
    "subCategory": "Tamil Printed Books"
  },
  {
    "id": 27,
    "category": "Archives Catalogue",
    "subCategory": "Thoothan"
  },
  {
    "id": 28,
    "category": "Archives Catalogue",
    "subCategory": "Thoothan"
  },
  {
    "id": 29,
    "category": "Library Catalogue",
    "subCategory": "000 - Reference"
  },
  {
    "id": 30,
    "category": "Library Catalogue",
    "subCategory": "039 - General Encyelopedic works"
  },
  {
    "id": 31,
    "category": "Library Catalogue",
    "subCategory": "041 -Religious Biography"
  },
  {
    "id": 32,
    "category": "Library Catalogue",
    "subCategory": "042 - Secular Biography"
  },
  {
    "id": 33,
    "category": "Library Catalogue",
    "subCategory": "043 - Saints Biography"
  },
  {
    "id": 34,
    "category": "Library Catalogue",
    "subCategory": "100 Philosophy"
  },
  {
    "id": 35,
    "category": "Library Catalogue",
    "subCategory": "150 Psychology"
  },
  {
    "id": 36,
    "category": "Library Catalogue",
    "subCategory": "170 Ethics (Moral Philosophy)"
  },
  {
    "id": 37,
    "category": "Library Catalogue",
    "subCategory": "180 Ancient Medieval Oriental Philosophy"
  },
  {
    "id": 38,
    "category": "Library Catalogue",
    "subCategory": "200 Religion"
  },
  {
    "id": 39,
    "category": "Library Catalogue",
    "subCategory": "201 Jesus Christ"
  },
  {
    "id": 40,
    "category": "Library Catalogue",
    "subCategory": "202 Christianity"
  },
  {
    "id": 41,
    "category": "Library Catalogue",
    "subCategory": "203 Religious Life"
  },
  {
    "id": 42,
    "category": "Library Catalogue",
    "subCategory": "220 Scripture"
  },
  {
    "id": 43,
    "category": "Library Catalogue",
    "subCategory": "221 Old Testament"
  },
  {
    "id": 44,
    "category": "Library Catalogue",
    "subCategory": "222 New Testament"
  },
  {
    "id": 45,
    "category": "Library Catalogue",
    "subCategory": "223 Gospels & Acts (Commentaries)"
  },
  {
    "id": 46,
    "category": "Library Catalogue",
    "subCategory": "230 Christianity - Christian Theology"
  },
  {
    "id": 47,
    "category": "Library Catalogue",
    "subCategory": "231 Spiritual Theology"
  },
  {
    "id": 48,
    "category": "Library Catalogue",
    "subCategory": "235 Mystical Theology"
  },
  {
    "id": 49,
    "category": "Library Catalogue",
    "subCategory": "237 Monastic Spirituality"
  },
  {
    "id": 50,
    "category": "Library Catalogue",
    "subCategory": "238 Catechism"
  },
  {
    "id": 51,
    "category": "Library Catalogue",
    "subCategory": "240 Devotional Theology"
  },
  {
    "id": 52,
    "category": "Library Catalogue",
    "subCategory": "244 Mariology"
  },
  {
    "id": 53,
    "category": "Library Catalogue",
    "subCategory": "251 Liturgy/Homilies/Sermon"
  },
  {
    "id": 54,
    "category": "Library Catalogue",
    "subCategory": "252 Meditation/Prayer/Contemplation"
  },
  {
    "id": 55,
    "category": "Library Catalogue",
    "subCategory": "253 Pastoral Theology"
  },
  {
    "id": 56,
    "category": "Library Catalogue",
    "subCategory": "253.1 Liberation Theology"
  },
  {
    "id": 57,
    "category": "Library Catalogue",
    "subCategory": "255 Religious Congregation & Orders"
  },
  {
    "id": 58,
    "category": "Library Catalogue",
    "subCategory": "255.1 Jesuits"
  },
  {
    "id": 59,
    "category": "Library Catalogue",
    "subCategory": "256 Constitution (SJ) GC Letters"
  },
  {
    "id": 60,
    "category": "Library Catalogue",
    "subCategory": "256.1 Jesuit History"
  },
  {
    "id": 61,
    "category": "Library Catalogue",
    "subCategory": "257 Jesuit Education"
  },
  {
    "id": 62,
    "category": "Library Catalogue",
    "subCategory": "257.1 Jesuit Formation"
  },
  {
    "id": 63,
    "category": "Library Catalogue",
    "subCategory": "257.2 Priestly Formation"
  },
  {
    "id": 64,
    "category": "Library Catalogue",
    "subCategory": "258 Spiritual Exercises (Jesuit Spirituality)"
  },
  {
    "id": 65,
    "category": "Library Catalogue",
    "subCategory": "258.1 Retreat"
  },
  {
    "id": 66,
    "category": "Library Catalogue",
    "subCategory": "259 Pastoral Care"
  },
  {
    "id": 67,
    "category": "Library Catalogue",
    "subCategory": "265 Sacraments"
  },
  {
    "id": 68,
    "category": "Library Catalogue",
    "subCategory": "266 Mission"
  },
  {
    "id": 69,
    "category": "Library Catalogue",
    "subCategory": "266.1 Jesuits in England"
  },
  {
    "id": 70,
    "category": "Library Catalogue",
    "subCategory": "266.2 Missions in India"
  },
  {
    "id": 71,
    "category": "Library Catalogue",
    "subCategory": "266.3 Bengal Mission"
  },
  {
    "id": 72,
    "category": "Library Catalogue",
    "subCategory": "266.4 Madurai Mission"
  },
  {
    "id": 73,
    "category": "Library Catalogue",
    "subCategory": "266.5 Bombay Mission"
  },
  {
    "id": 74,
    "category": "Library Catalogue",
    "subCategory": "266.6 Jesuits in Karnataka"
  },
  {
    "id": 75,
    "category": "Library Catalogue",
    "subCategory": "266.7 Madurai Province"
  },
  {
    "id": 76,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.1 Ignatius of Loyola"
  },
  {
    "id": 77,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.2 St John De Britto"
  },
  {
    "id": 78,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.3 St Francis Xavier"
  },
  {
    "id": 79,
    "category": "Library Catalogue",
    "subCategory": "267 Jesuit Saints - 267.4 Jesuit Biography"
  },
  {
    "id": 80,
    "category": "Library Catalogue",
    "subCategory": "267.1 Ignatius of Loyola"
  },
  {
    "id": 81,
    "category": "Library Catalogue",
    "subCategory": "267.2 St John De Britto"
  },
  {
    "id": 82,
    "category": "Library Catalogue",
    "subCategory": "267.3 St Francis Xavier"
  },
  {
    "id": 83,
    "category": "Library Catalogue",
    "subCategory": "267.4 Jesuit Biography"
  },
  {
    "id": 84,
    "category": "Library Catalogue",
    "subCategory": "270 Church History"
  },
  {
    "id": 85,
    "category": "Library Catalogue",
    "subCategory": "275 History of Christianity in Asia"
  },
  {
    "id": 86,
    "category": "Library Catalogue",
    "subCategory": "275.1 Church in India"
  },
  {
    "id": 87,
    "category": "Library Catalogue",
    "subCategory": "275.2 Church in Tamil Nadu"
  },
  {
    "id": 88,
    "category": "Library Catalogue",
    "subCategory": "275.4 Church in Sri Lanka"
  },
  {
    "id": 89,
    "category": "Library Catalogue",
    "subCategory": "282 Roman Catholic Church"
  },
  {
    "id": 90,
    "category": "Library Catalogue",
    "subCategory": "282.1 Canon Law"
  },
  {
    "id": 91,
    "category": "Library Catalogue",
    "subCategory": "282.2 Papal Teaching"
  },
  {
    "id": 92,
    "category": "Library Catalogue",
    "subCategory": "282.3 Councils"
  },
  {
    "id": 93,
    "category": "Library Catalogue",
    "subCategory": "284 Protestantism"
  },
  {
    "id": 94,
    "category": "Library Catalogue",
    "subCategory": "290 Comparative Religion (Other Religions)"
  },
  {
    "id": 95,
    "category": "Library Catalogue",
    "subCategory": "294 Hinduism (Bhagavad Gita Epics Advaita)"
  },
  {
    "id": 96,
    "category": "Library Catalogue",
    "subCategory": "294.1 Indian Philosophy"
  },
  {
    "id": 97,
    "category": "Library Catalogue",
    "subCategory": "294.2 Indian Spirituality"
  },
  {
    "id": 98,
    "category": "Library Catalogue",
    "subCategory": "297 Islam"
  },
  {
    "id": 99,
    "category": "Library Catalogue",
    "subCategory": "298 Buddhism"
  },
  {
    "id": 100,
    "category": "Library Catalogue",
    "subCategory": "299 Spirituality in General"
  },
  {
    "id": 101,
    "category": "Library Catalogue",
    "subCategory": "299.1 Spiritual Narratives"
  },
  {
    "id": 102,
    "category": "Library Catalogue",
    "subCategory": "299.2 Mission History"
  },
  {
    "id": 103,
    "category": "Library Catalogue",
    "subCategory": "300 Social Science"
  },
  {
    "id": 104,
    "category": "Library Catalogue",
    "subCategory": "300.1 Secularism"
  },
  {
    "id": 105,
    "category": "Library Catalogue",
    "subCategory": "301 Sociology & Anthropology"
  },
  {
    "id": 106,
    "category": "Library Catalogue",
    "subCategory": "305 Women"
  },
  {
    "id": 107,
    "category": "Library Catalogue",
    "subCategory": "307 Tribes & Ethnic Groups"
  },
  {
    "id": 108,
    "category": "Library Catalogue",
    "subCategory": "307.1 Caste System"
  },
  {
    "id": 109,
    "category": "Library Catalogue",
    "subCategory": "308 Indian Culture"
  },
  {
    "id": 110,
    "category": "Library Catalogue",
    "subCategory": "309 Human Rights"
  },
  {
    "id": 111,
    "category": "Library Catalogue",
    "subCategory": "309.1 Social Justice"
  },
  {
    "id": 112,
    "category": "Library Catalogue",
    "subCategory": "320 Political Science"
  },
  {
    "id": 113,
    "category": "Library Catalogue",
    "subCategory": "330 Economics"
  },
  {
    "id": 114,
    "category": "Library Catalogue",
    "subCategory": "348 Law ( Statutes Regulations Cases )"
  },
  {
    "id": 115,
    "category": "Library Catalogue",
    "subCategory": "370 Education"
  },
  {
    "id": 116,
    "category": "Library Catalogue",
    "subCategory": "376 Moral Education"
  },
  {
    "id": 117,
    "category": "Library Catalogue",
    "subCategory": "376 Moral Education"
  },
  {
    "id": 118,
    "category": "Library Catalogue",
    "subCategory": "377 Rel Education (Youth)"
  },
  {
    "id": 119,
    "category": "Library Catalogue",
    "subCategory": "378 Rel Education (Youth)"
  },
  {
    "id": 120,
    "category": "Library Catalogue",
    "subCategory": "379 Rel Education (Youth)"
  },
  {
    "id": 121,
    "category": "Library Catalogue",
    "subCategory": "380 Communication (Media)"
  },
  {
    "id": 122,
    "category": "Library Catalogue",
    "subCategory": "380 Rel Education (Youth)"
  },
  {
    "id": 123,
    "category": "Library Catalogue",
    "subCategory": "381 Rel Education (Youth)"
  },
  {
    "id": 124,
    "category": "Library Catalogue",
    "subCategory": "382 Rel Education (Youth)"
  },
  {
    "id": 125,
    "category": "Library Catalogue",
    "subCategory": "383 Rel Education (Youth)"
  },
  {
    "id": 126,
    "category": "Library Catalogue",
    "subCategory": "384 Rel Education (Youth)"
  },
  {
    "id": 127,
    "category": "Library Catalogue",
    "subCategory": "385 Rel Education (Youth)"
  },
  {
    "id": 128,
    "category": "Library Catalogue",
    "subCategory": "386 Rel Education (Youth)"
  },
  {
    "id": 129,
    "category": "Library Catalogue",
    "subCategory": "387 Rel Education (Youth)"
  },
  {
    "id": 130,
    "category": "Library Catalogue",
    "subCategory": "388 Rel Education (Youth)"
  },
  {
    "id": 131,
    "category": "Library Catalogue",
    "subCategory": "389 Rel Education (Youth)"
  },
  {
    "id": 132,
    "category": "Library Catalogue",
    "subCategory": "390 Rel Education (Youth)"
  },
  {
    "id": 133,
    "category": "Library Catalogue",
    "subCategory": "391 Rel Education (Youth)"
  },
  {
    "id": 134,
    "category": "Library Catalogue",
    "subCategory": "392 Rel Education (Youth)"
  },
  {
    "id": 135,
    "category": "Library Catalogue",
    "subCategory": "393 Rel Education (Youth)"
  },
  {
    "id": 136,
    "category": "Library Catalogue",
    "subCategory": "394 Rel Education (Youth)"
  },
  {
    "id": 137,
    "category": "Library Catalogue",
    "subCategory": "395 Rel Education (Youth)"
  },
  {
    "id": 138,
    "category": "Library Catalogue",
    "subCategory": "396 Rel Education (Youth)"
  },
  {
    "id": 139,
    "category": "Library Catalogue",
    "subCategory": "397 Rel Education (Youth)"
  },
  {
    "id": 140,
    "category": "Library Catalogue",
    "subCategory": "398 Folklore"
  },
  {
    "id": 141,
    "category": "Library Catalogue",
    "subCategory": "398 Rel Education (Youth)"
  },
  {
    "id": 142,
    "category": "Library Catalogue",
    "subCategory": "399 Rel Education (Youth)"
  },
  {
    "id": 143,
    "category": "Library Catalogue",
    "subCategory": "400 Rel Education (Youth)"
  },
  {
    "id": 144,
    "category": "Library Catalogue",
    "subCategory": "401 Rel Education (Youth)"
  },
  {
    "id": 145,
    "category": "Library Catalogue",
    "subCategory": "402 Rel Education (Youth)"
  },
  {
    "id": 146,
    "category": "Library Catalogue",
    "subCategory": "503 Sciences (Miscellaneous)"
  },
  {
    "id": 147,
    "category": "Library Catalogue",
    "subCategory": "577 Ecology"
  },
  {
    "id": 148,
    "category": "Library Catalogue",
    "subCategory": "580 Plants"
  },
  {
    "id": 149,
    "category": "Library Catalogue",
    "subCategory": "610 Medical Science"
  },
  {
    "id": 150,
    "category": "Library Catalogue",
    "subCategory": "620 Engineering"
  },
  {
    "id": 151,
    "category": "Library Catalogue",
    "subCategory": "658 General Management & 690 Buildings"
  },
  {
    "id": 152,
    "category": "Library Catalogue",
    "subCategory": "700.1 Arts (Miscellaneous)"
  },
  {
    "id": 153,
    "category": "Library Catalogue",
    "subCategory": "720 Architecture"
  },
  {
    "id": 154,
    "category": "Library Catalogue",
    "subCategory": "755 Painting (Religion)"
  },
  {
    "id": 155,
    "category": "Library Catalogue",
    "subCategory": "780 Music"
  },
  {
    "id": 156,
    "category": "Library Catalogue",
    "subCategory": "791 Dancing"
  },
  {
    "id": 157,
    "category": "Library Catalogue",
    "subCategory": "804 Literature on Tamil"
  },
  {
    "id": 158,
    "category": "Library Catalogue",
    "subCategory": "895 Literature of East & Southeast Asia"
  },
  {
    "id": 159,
    "category": "Library Catalogue",
    "subCategory": "909 World History (Countries)"
  },
  {
    "id": 160,
    "category": "Library Catalogue",
    "subCategory": "909.1 World History (Nations)"
  },
  {
    "id": 161,
    "category": "Library Catalogue",
    "subCategory": "910 Geography & Travel"
  },
  {
    "id": 162,
    "category": "Library Catalogue",
    "subCategory": "947 Russia (East Europe)"
  },
  {
    "id": 163,
    "category": "Library Catalogue",
    "subCategory": "950 History of Asia"
  },
  {
    "id": 164,
    "category": "Library Catalogue",
    "subCategory": "950 History of Asia - 950.1 Far East"
  },
  {
    "id": 165,
    "category": "Library Catalogue",
    "subCategory": "950.2 Sri Lanka"
  },
  {
    "id": 166,
    "category": "Library Catalogue",
    "subCategory": "950.3 Indo-Portuguese"
  },
  {
    "id": 167,
    "category": "Library Catalogue",
    "subCategory": "951 China"
  },
  {
    "id": 168,
    "category": "Library Catalogue",
    "subCategory": "952 Japan"
  },
  {
    "id": 169,
    "category": "Library Catalogue",
    "subCategory": "954 History of India"
  },
  {
    "id": 170,
    "category": "Library Catalogue",
    "subCategory": "954.1 Tamil Nadu"
  },
  {
    "id": 171,
    "category": "Library Catalogue",
    "subCategory": "954.2 Madras"
  },
  {
    "id": 172,
    "category": "Library Catalogue",
    "subCategory": "990 General History / 990.1 America (North & South"
  },
  {
    "id": 173,
    "category": "Library Catalogue",
    "subCategory": "Fr Pedro Arrupe SJ"
  },
  {
    "id": 174,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Poems (Kavithaigal)"
  },
  {
    "id": 175,
    "category": "Tamil Catalogue",
    "subCategory": "Arts of India ( India Kalaigal )"
  },
  {
    "id": 176,
    "category": "Tamil Catalogue",
    "subCategory": "Arutchathanangal"
  },
  {
    "id": 177,
    "category": "Tamil Catalogue",
    "subCategory": "Awareness"
  },
  {
    "id": 178,
    "category": "Tamil Catalogue",
    "subCategory": "Awarness"
  },
  {
    "id": 179,
    "category": "Tamil Catalogue",
    "subCategory": "Botany"
  },
  {
    "id": 180,
    "category": "Tamil Catalogue",
    "subCategory": "Catechism"
  },
  {
    "id": 181,
    "category": "Tamil Catalogue",
    "subCategory": "Christian Literature"
  },
  {
    "id": 182,
    "category": "Tamil Catalogue",
    "subCategory": "Christian Songs"
  },
  {
    "id": 183,
    "category": "Tamil Catalogue",
    "subCategory": "Christianity"
  },
  {
    "id": 184,
    "category": "Tamil Catalogue",
    "subCategory": "Common in Tamil Language"
  },
  {
    "id": 185,
    "category": "Tamil Catalogue",
    "subCategory": "Comparative Grammer (Oppilakkanam)"
  },
  {
    "id": 186,
    "category": "Tamil Catalogue",
    "subCategory": "Dioceses"
  },
  {
    "id": 187,
    "category": "Tamil Catalogue",
    "subCategory": "Drama"
  },
  {
    "id": 188,
    "category": "Tamil Catalogue",
    "subCategory": "Education"
  },
  {
    "id": 189,
    "category": "Tamil Catalogue",
    "subCategory": "Essays on literature (Ilakiya Katturaigal)"
  },
  {
    "id": 190,
    "category": "Tamil Catalogue",
    "subCategory": "Eucharist (Narkarunai Veera Sabai)"
  },
  {
    "id": 191,
    "category": "Tamil Catalogue",
    "subCategory": "General knowledge (Essays)"
  },
  {
    "id": 192,
    "category": "Tamil Catalogue",
    "subCategory": "Hinduism"
  },
  {
    "id": 193,
    "category": "Tamil Catalogue",
    "subCategory": "History of Church"
  },
  {
    "id": 194,
    "category": "Tamil Catalogue",
    "subCategory": "History of India"
  },
  {
    "id": 195,
    "category": "Tamil Catalogue",
    "subCategory": "History of Tamil Literature (Tamil Ilakkiya Varalaru)"
  },
  {
    "id": 196,
    "category": "Tamil Catalogue",
    "subCategory": "History of Temples"
  },
  {
    "id": 197,
    "category": "Tamil Catalogue",
    "subCategory": "Holy Bible"
  },
  {
    "id": 198,
    "category": "Tamil Catalogue",
    "subCategory": "Human Rights"
  },
  {
    "id": 199,
    "category": "Tamil Catalogue",
    "subCategory": "Jesuit History"
  },
  {
    "id": 200,
    "category": "Tamil Catalogue",
    "subCategory": "Leaders in India"
  },
  {
    "id": 201,
    "category": "Tamil Catalogue",
    "subCategory": "Martyr Deva Sahayam Pillai"
  },
  {
    "id": 202,
    "category": "Tamil Catalogue",
    "subCategory": "Media Education"
  },
  {
    "id": 203,
    "category": "Tamil Catalogue",
    "subCategory": "Medicine"
  },
  {
    "id": 204,
    "category": "Tamil Catalogue",
    "subCategory": "Mother Mary (Mariyannai)"
  },
  {
    "id": 205,
    "category": "Tamil Catalogue",
    "subCategory": "Nattar Vazhakkatriyal&Panpaadu"
  },
  {
    "id": 206,
    "category": "Tamil Catalogue",
    "subCategory": "Politics"
  },
  {
    "id": 207,
    "category": "Tamil Catalogue",
    "subCategory": "Politics (Aracial)"
  },
  {
    "id": 208,
    "category": "Tamil Catalogue",
    "subCategory": "Prayer Book"
  },
  {
    "id": 209,
    "category": "Tamil Catalogue",
    "subCategory": "Proverbs"
  },
  {
    "id": 210,
    "category": "Tamil Catalogue",
    "subCategory": "Religions of Our Country"
  },
  {
    "id": 211,
    "category": "Tamil Catalogue",
    "subCategory": "Robert De Nobili SJ"
  },
  {
    "id": 212,
    "category": "Tamil Catalogue",
    "subCategory": "Saints"
  },
  {
    "id": 213,
    "category": "Tamil Catalogue",
    "subCategory": "Secular Biography"
  },
  {
    "id": 214,
    "category": "Tamil Catalogue",
    "subCategory": "Short Stories"
  },
  {
    "id": 215,
    "category": "Tamil Catalogue",
    "subCategory": "Social Justice (Samuga Neethi)"
  },
  {
    "id": 216,
    "category": "Tamil Catalogue",
    "subCategory": "Spiritual"
  },
  {
    "id": 217,
    "category": "Tamil Catalogue",
    "subCategory": "Spiritual Exercises"
  },
  {
    "id": 218,
    "category": "Tamil Catalogue",
    "subCategory": "Spiritual Short Stories"
  },
  {
    "id": 219,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Literature"
  },
  {
    "id": 220,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Literature Stories"
  },
  {
    "id": 221,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Nadu"
  },
  {
    "id": 222,
    "category": "Tamil Catalogue",
    "subCategory": "Tamil Novel"
  },
  {
    "id": 223,
    "category": "Tamil Catalogue",
    "subCategory": "Theology"
  },
  {
    "id": 224,
    "category": "Tamil Catalogue",
    "subCategory": "Thesis (Aaivu Katturaigal)"
  },
  {
    "id": 225,
    "category": "Tamil Catalogue",
    "subCategory": "Thiruchabai"
  },
  {
    "id": 226,
    "category": "Tamil Catalogue",
    "subCategory": "Thirukkural"
  },
  {
    "id": 227,
    "category": "Tamil Catalogue",
    "subCategory": "World Tamil Conference (Ulaga Tamil Manadu)"
  }
];
